var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHanBear = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2014 1674.641",
    viewBox: "0 0 2014 1674.641",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.9927636%",
    cy: "129.500644%",
    fx: "49.9927636%",
    fy: "129.500644%",
    r: "130.639296%",
    gradientTransform: "translate(0.499928,1.295006),scale(0.500000,1.000000),translate(-0.499928,-1.295006)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232A64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2127.94439%",
    y1: "59.8111224%",
    x2: "548.205102%",
    y2: "52.3084694%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1971.40051%",
    y1: "59.0669388%",
    x2: "391.661224%",
    y2: "51.5642857%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1814.70138%",
    y1: "58.3228571%",
    x2: "235.096789%",
    y2: "50.8202041%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1657.80153%",
    y1: "57.5787755%",
    x2: "78.0622449%",
    y2: "50.0760204%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1501.25765%",
    y1: "56.8345918%",
    x2: "-78.4821429%",
    y2: "49.3319388%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1344.71327%",
    y1: "56.0905102%",
    x2: "-235.026531%",
    y2: "48.5877551%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1187.65867%",
    y1: "55.3464286%",
    x2: "-392.080612%",
    y2: "47.8436735%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1031.11378%",
    y1: "54.6022449%",
    x2: "-548.62551%",
    y2: "47.0994898%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "874.569898%",
    y1: "53.8581633%",
    x2: "-705.169388%",
    y2: "46.3554082%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "718.02551%",
    y1: "53.1139796%",
    x2: "-861.713776%",
    y2: "45.6112245%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2114.5898%",
    y1: "59.737449%",
    x2: "534.85051%",
    y2: "52.2347959%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "562.50102%",
    y1: "52.3768367%",
    x2: "-1017.23827%",
    y2: "44.8740816%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "549.146429%",
    y1: "52.3031633%",
    x2: "-1030.59337%",
    y2: "44.8005102%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1961.08776%",
    y1: "68.6320084%",
    x2: "381.347959%",
    y2: "53.2497908%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1801.34741%",
    y1: "58.2492857%",
    x2: "221.742826%",
    y2: "50.7465306%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1647.48878%",
    y1: "65.5807531%",
    x2: "67.7494898%",
    y2: "50.1985356%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1487.90255%",
    y1: "56.7609184%",
    x2: "-91.8372449%",
    y2: "49.2582653%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1334.4%",
    y1: "62.5294979%",
    x2: "-245.339286%",
    y2: "47.1472803%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1174.30408%",
    y1: "55.2727551%",
    x2: "-405.435714%",
    y2: "47.77%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1020.80153%",
    y1: "59.4782427%",
    x2: "-558.938265%",
    y2: "44.0960251%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "861.214796%",
    y1: "53.7843878%",
    x2: "-718.52449%",
    y2: "46.2817347%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "707.712245%",
    y1: "56.4269874%",
    x2: "-872.027041%",
    y2: "41.0447699%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1954.58316%",
    y1: "73.1544271%",
    x2: "374.843367%",
    y2: "54.0067708%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1640.98469%",
    y1: "69.35625%",
    x2: "61.244898%",
    y2: "50.2085937%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1327.89541%",
    y1: "65.5580729%",
    x2: "-251.843878%",
    y2: "46.4104167%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1014.29694%",
    y1: "61.7598958%",
    x2: "-565.442347%",
    y2: "42.6122396%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "701.208673%",
    y1: "57.9617187%",
    x2: "-878.531122%",
    y2: "38.8143229%",
    id: "linearGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2028.08265%",
    y1: "59.8111224%",
    x2: "-448.343367%",
    y2: "52.3084694%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1871.37016%",
    y1: "59.0669388%",
    x2: "-291.765572%",
    y2: "51.5642857%",
    id: "linearGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1714.48367%",
    y1: "58.3228571%",
    x2: "-134.744388%",
    y2: "50.8202041%",
    id: "linearGradient-31"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1557.9398%",
    y1: "57.5787755%",
    x2: "21.8%",
    y2: "50.0760204%",
    id: "linearGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1401.39541%",
    y1: "56.8345918%",
    x2: "178.344388%",
    y2: "49.3319388%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1244.34082%",
    y1: "56.0905102%",
    x2: "335.398469%",
    y2: "48.5877551%",
    id: "linearGradient-34"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1087.79643%",
    y1: "55.3464286%",
    x2: "491.942857%",
    y2: "47.8436735%",
    id: "linearGradient-35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-931.252041%",
    y1: "54.6022449%",
    x2: "648.487245%",
    y2: "47.0994898%",
    id: "linearGradient-36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-774.707653%",
    y1: "53.8581633%",
    x2: "805.031633%",
    y2: "46.3554082%",
    id: "linearGradient-37"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-617.653571%",
    y1: "53.1139796%",
    x2: "962.086224%",
    y2: "45.6112245%",
    id: "linearGradient-38"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2014.72806%",
    y1: "59.737449%",
    x2: "-434.988265%",
    y2: "52.2347959%",
    id: "linearGradient-39"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-462.638776%",
    y1: "52.3768367%",
    x2: "1117.10051%",
    y2: "44.8740816%",
    id: "linearGradient-40"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-449.284184%",
    y1: "52.3031633%",
    x2: "1130.45561%",
    y2: "44.8005102%",
    id: "linearGradient-41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1861.05828%",
    y1: "68.6320084%",
    x2: "-281.453697%",
    y2: "53.2497908%",
    id: "linearGradient-42"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1701.12908%",
    y1: "58.2492857%",
    x2: "-121.389286%",
    y2: "50.7465306%",
    id: "linearGradient-43"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1547.62653%",
    y1: "65.5807531%",
    x2: "32.1127551%",
    y2: "50.1985356%",
    id: "linearGradient-44"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1388.04082%",
    y1: "56.7609184%",
    x2: "191.69898%",
    y2: "49.2582653%",
    id: "linearGradient-45"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1234.02806%",
    y1: "62.5294979%",
    x2: "345.711735%",
    y2: "47.1472803%",
    id: "linearGradient-46"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1074.44184%",
    y1: "55.2727551%",
    x2: "505.297959%",
    y2: "47.77%",
    id: "linearGradient-47"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-920.939286%",
    y1: "59.4782427%",
    x2: "658.8%",
    y2: "44.0960251%",
    id: "linearGradient-48"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-761.353061%",
    y1: "53.7843878%",
    x2: "818.386224%",
    y2: "46.2817347%",
    id: "linearGradient-49"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-607.340816%",
    y1: "56.4269874%",
    x2: "972.39898%",
    y2: "41.0447699%",
    id: "linearGradient-50"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1854.55476%",
    y1: "73.1544271%",
    x2: "-274.949659%",
    y2: "54.0067708%",
    id: "linearGradient-51"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1541.12245%",
    y1: "69.35625%",
    x2: "38.6173469%",
    y2: "50.2085937%",
    id: "linearGradient-52"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1227.52347%",
    y1: "65.5580729%",
    x2: "352.215816%",
    y2: "46.4104167%",
    id: "linearGradient-53"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-914.434694%",
    y1: "61.7598958%",
    x2: "665.304592%",
    y2: "42.6122396%",
    id: "linearGradient-54"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-600.836224%",
    y1: "57.9617187%",
    x2: "978.903571%",
    y2: "38.8143229%",
    id: "linearGradient-55"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2127.94439%",
    y1: "59.8780612%",
    x2: "548.205102%",
    y2: "52.3753061%",
    id: "linearGradient-56"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1971.40051%",
    y1: "59.1338776%",
    x2: "391.661224%",
    y2: "51.6312245%",
    id: "linearGradient-57"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1814.70138%",
    y1: "58.3897959%",
    x2: "235.096789%",
    y2: "50.8870408%",
    id: "linearGradient-58"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1657.80153%",
    y1: "57.6456122%",
    x2: "78.0622449%",
    y2: "50.1429592%",
    id: "linearGradient-59"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1501.25765%",
    y1: "56.9015306%",
    x2: "-78.4821429%",
    y2: "49.3987755%",
    id: "linearGradient-60"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1344.71327%",
    y1: "56.157449%",
    x2: "-235.026531%",
    y2: "48.6546939%",
    id: "linearGradient-61"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1187.65867%",
    y1: "55.4132653%",
    x2: "-392.080612%",
    y2: "47.9105102%",
    id: "linearGradient-62"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1031.11378%",
    y1: "54.6690816%",
    x2: "-548.62551%",
    y2: "47.1664286%",
    id: "linearGradient-63"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "874.569898%",
    y1: "53.925%",
    x2: "-705.169388%",
    y2: "46.4222449%",
    id: "linearGradient-64"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "718.02551%",
    y1: "53.1809184%",
    x2: "-861.713776%",
    y2: "45.6781633%",
    id: "linearGradient-65"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2114.5898%",
    y1: "59.8043878%",
    x2: "534.85051%",
    y2: "52.3017347%",
    id: "linearGradient-66"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "562.50102%",
    y1: "52.4437755%",
    x2: "-1017.23827%",
    y2: "44.9410204%",
    id: "linearGradient-67"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "549.146429%",
    y1: "52.370102%",
    x2: "-1030.59337%",
    y2: "44.8673469%",
    id: "linearGradient-68"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1961.08776%",
    y1: "68.5598326%",
    x2: "381.347959%",
    y2: "53.1776151%",
    id: "linearGradient-69"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1801.34741%",
    y1: "58.3161224%",
    x2: "221.742826%",
    y2: "50.8134694%",
    id: "linearGradient-70"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1647.48878%",
    y1: "65.5085774%",
    x2: "67.7494898%",
    y2: "50.126569%",
    id: "linearGradient-71"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1487.90255%",
    y1: "56.8278571%",
    x2: "-91.8372449%",
    y2: "49.3252041%",
    id: "linearGradient-72"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1334.4%",
    y1: "62.4575314%",
    x2: "-245.339286%",
    y2: "47.0753138%",
    id: "linearGradient-73"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1174.30408%",
    y1: "55.3395918%",
    x2: "-405.435714%",
    y2: "47.8369388%",
    id: "linearGradient-74"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1020.80153%",
    y1: "59.4062762%",
    x2: "-558.938265%",
    y2: "44.0240586%",
    id: "linearGradient-75"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "861.214796%",
    y1: "53.8513265%",
    x2: "-718.52449%",
    y2: "46.3486735%",
    id: "linearGradient-76"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "707.712245%",
    y1: "56.3550209%",
    x2: "-872.027041%",
    y2: "40.9728033%",
    id: "linearGradient-77"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1954.58316%",
    y1: "73.0645833%",
    x2: "374.843367%",
    y2: "53.9171875%",
    id: "linearGradient-78"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1640.98469%",
    y1: "69.2666667%",
    x2: "61.244898%",
    y2: "50.1190104%",
    id: "linearGradient-79"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1327.89541%",
    y1: "65.4684896%",
    x2: "-251.843878%",
    y2: "46.3208333%",
    id: "linearGradient-80"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1014.29694%",
    y1: "61.6703125%",
    x2: "-565.442347%",
    y2: "42.5226562%",
    id: "linearGradient-81"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "701.208673%",
    y1: "57.8721354%",
    x2: "-878.531122%",
    y2: "38.7244792%",
    id: "linearGradient-82"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2028.08265%",
    y1: "59.8780612%",
    x2: "-448.343367%",
    y2: "52.3753061%",
    id: "linearGradient-83"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1871.37016%",
    y1: "59.1338776%",
    x2: "-291.765572%",
    y2: "51.6312245%",
    id: "linearGradient-84"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1714.48367%",
    y1: "58.3897959%",
    x2: "-134.744388%",
    y2: "50.8870408%",
    id: "linearGradient-85"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1557.9398%",
    y1: "57.6456122%",
    x2: "21.8%",
    y2: "50.1429592%",
    id: "linearGradient-86"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1401.39541%",
    y1: "56.9015306%",
    x2: "178.344388%",
    y2: "49.3987755%",
    id: "linearGradient-87"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1244.34082%",
    y1: "56.157449%",
    x2: "335.398469%",
    y2: "48.6546939%",
    id: "linearGradient-88"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1087.79643%",
    y1: "55.4132653%",
    x2: "491.942857%",
    y2: "47.9105102%",
    id: "linearGradient-89"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-931.252041%",
    y1: "54.6690816%",
    x2: "648.487245%",
    y2: "47.1664286%",
    id: "linearGradient-90"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-774.707653%",
    y1: "53.925%",
    x2: "805.031633%",
    y2: "46.4222449%",
    id: "linearGradient-91"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-617.653571%",
    y1: "53.1809184%",
    x2: "962.086224%",
    y2: "45.6781633%",
    id: "linearGradient-92"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2014.72806%",
    y1: "59.8043878%",
    x2: "-434.988265%",
    y2: "52.3017347%",
    id: "linearGradient-93"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-462.638776%",
    y1: "52.4437755%",
    x2: "1117.10051%",
    y2: "44.9410204%",
    id: "linearGradient-94"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-449.284184%",
    y1: "52.370102%",
    x2: "1130.45561%",
    y2: "44.8673469%",
    id: "linearGradient-95"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1861.05828%",
    y1: "68.5598326%",
    x2: "-281.453697%",
    y2: "53.1776151%",
    id: "linearGradient-96"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1701.12908%",
    y1: "58.3161224%",
    x2: "-121.389286%",
    y2: "50.8134694%",
    id: "linearGradient-97"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1547.62653%",
    y1: "65.5085774%",
    x2: "32.1127551%",
    y2: "50.126569%",
    id: "linearGradient-98"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1388.04082%",
    y1: "56.8278571%",
    x2: "191.69898%",
    y2: "49.3252041%",
    id: "linearGradient-99"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1234.02806%",
    y1: "62.4575314%",
    x2: "345.711735%",
    y2: "47.0753138%",
    id: "linearGradient-100"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1074.44184%",
    y1: "55.3395918%",
    x2: "505.297959%",
    y2: "47.8369388%",
    id: "linearGradient-101"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-920.939286%",
    y1: "59.4062762%",
    x2: "658.8%",
    y2: "44.0240586%",
    id: "linearGradient-102"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-761.353061%",
    y1: "53.8513265%",
    x2: "818.386224%",
    y2: "46.3486735%",
    id: "linearGradient-103"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-607.340816%",
    y1: "56.3550209%",
    x2: "972.39898%",
    y2: "40.9728033%",
    id: "linearGradient-104"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1854.55476%",
    y1: "73.0645833%",
    x2: "-274.949659%",
    y2: "53.9171875%",
    id: "linearGradient-105"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1541.12245%",
    y1: "69.2666667%",
    x2: "38.6173469%",
    y2: "50.1190104%",
    id: "linearGradient-106"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1227.52347%",
    y1: "65.4684896%",
    x2: "352.215816%",
    y2: "46.3208333%",
    id: "linearGradient-107"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-914.434694%",
    y1: "61.6703125%",
    x2: "665.304592%",
    y2: "42.5226562%",
    id: "linearGradient-108"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-600.836224%",
    y1: "57.8721354%",
    x2: "978.903571%",
    y2: "38.7244792%",
    id: "linearGradient-109"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2127.94439%",
    y1: "59.8316327%",
    x2: "548.205102%",
    y2: "52.3288776%",
    id: "linearGradient-110"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1971.40051%",
    y1: "59.087449%",
    x2: "391.661224%",
    y2: "51.5846939%",
    id: "linearGradient-111"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1814.70138%",
    y1: "58.3433673%",
    x2: "235.096789%",
    y2: "50.8406122%",
    id: "linearGradient-112"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1657.80153%",
    y1: "57.5991837%",
    x2: "78.0622449%",
    y2: "50.0965306%",
    id: "linearGradient-113"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1501.25765%",
    y1: "56.855102%",
    x2: "-78.4821429%",
    y2: "49.3523469%",
    id: "linearGradient-114"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1344.71327%",
    y1: "56.1109184%",
    x2: "-235.026531%",
    y2: "48.6082653%",
    id: "linearGradient-115"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1187.65867%",
    y1: "55.3668367%",
    x2: "-392.080612%",
    y2: "47.8640816%",
    id: "linearGradient-116"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1031.11378%",
    y1: "54.6226531%",
    x2: "-548.62551%",
    y2: "47.12%",
    id: "linearGradient-117"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "874.569898%",
    y1: "53.8785714%",
    x2: "-705.169388%",
    y2: "46.3758163%",
    id: "linearGradient-118"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "718.02551%",
    y1: "53.1343878%",
    x2: "-861.713776%",
    y2: "45.6317347%",
    id: "linearGradient-119"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2114.5898%",
    y1: "59.7579592%",
    x2: "534.85051%",
    y2: "52.2552041%",
    id: "linearGradient-120"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "562.50102%",
    y1: "52.3972449%",
    x2: "-1017.23827%",
    y2: "44.8945918%",
    id: "linearGradient-121"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "549.146429%",
    y1: "52.3236735%",
    x2: "-1030.59337%",
    y2: "44.8209184%",
    id: "linearGradient-122"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1961.08776%",
    y1: "68.6738494%",
    x2: "381.347959%",
    y2: "53.2916318%",
    id: "linearGradient-123"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1801.34741%",
    y1: "58.2696939%",
    x2: "221.742826%",
    y2: "50.7669388%",
    id: "linearGradient-124"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1647.48878%",
    y1: "65.6225941%",
    x2: "67.7494898%",
    y2: "50.2403766%",
    id: "linearGradient-125"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1487.90255%",
    y1: "56.7814286%",
    x2: "-91.8372449%",
    y2: "49.2786735%",
    id: "linearGradient-126"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1334.4%",
    y1: "62.5713389%",
    x2: "-245.339286%",
    y2: "47.1893305%",
    id: "linearGradient-127"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1174.30408%",
    y1: "55.2931633%",
    x2: "-405.435714%",
    y2: "47.7905102%",
    id: "linearGradient-128"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1020.80153%",
    y1: "59.5200837%",
    x2: "-558.938265%",
    y2: "44.1378661%",
    id: "linearGradient-129"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "861.214796%",
    y1: "53.804898%",
    x2: "-718.52449%",
    y2: "46.3021429%",
    id: "linearGradient-130"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "707.712245%",
    y1: "56.4688285%",
    x2: "-872.027041%",
    y2: "41.0868201%",
    id: "linearGradient-131"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1954.58316%",
    y1: "73.2065104%",
    x2: "374.843367%",
    y2: "54.0591146%",
    id: "linearGradient-132"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1640.98469%",
    y1: "69.4083333%",
    x2: "61.244898%",
    y2: "50.2609375%",
    id: "linearGradient-133"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1327.89541%",
    y1: "65.6104167%",
    x2: "-251.843878%",
    y2: "46.4627604%",
    id: "linearGradient-134"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1014.29694%",
    y1: "61.8119792%",
    x2: "-565.442347%",
    y2: "42.6645833%",
    id: "linearGradient-135"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "701.208673%",
    y1: "58.0140625%",
    x2: "-878.531122%",
    y2: "38.8664063%",
    id: "linearGradient-136"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2128.18878%",
    y1: "59.8316327%",
    x2: "548.44949%",
    y2: "52.3288776%",
    id: "linearGradient-137"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1971.13469%",
    y1: "59.087449%",
    x2: "391.394898%",
    y2: "51.5846939%",
    id: "linearGradient-138"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1814.59031%",
    y1: "58.3433673%",
    x2: "234.85051%",
    y2: "50.8406122%",
    id: "linearGradient-139"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1658.04592%",
    y1: "57.5991837%",
    x2: "78.3066327%",
    y2: "50.0965306%",
    id: "linearGradient-140"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1501.3735%",
    y1: "56.855102%",
    x2: "-78.2315942%",
    y2: "49.3523469%",
    id: "linearGradient-141"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1344.44694%",
    y1: "56.1109184%",
    x2: "-235.292347%",
    y2: "48.6082653%",
    id: "linearGradient-142"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1187.90306%",
    y1: "55.3668367%",
    x2: "-391.836735%",
    y2: "47.8640816%",
    id: "linearGradient-143"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1031.35816%",
    y1: "54.6226531%",
    x2: "-548.381122%",
    y2: "47.12%",
    id: "linearGradient-144"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "874.304082%",
    y1: "53.8785714%",
    x2: "-705.435714%",
    y2: "46.3758163%",
    id: "linearGradient-145"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "717.759694%",
    y1: "53.1343878%",
    x2: "-861.980102%",
    y2: "45.6317347%",
    id: "linearGradient-146"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2114.83418%",
    y1: "59.7579592%",
    x2: "535.094898%",
    y2: "52.2552041%",
    id: "linearGradient-147"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "562.745408%",
    y1: "52.3972449%",
    x2: "-1016.99439%",
    y2: "44.8945918%",
    id: "linearGradient-148"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "549.390306%",
    y1: "52.3236735%",
    x2: "-1030.34949%",
    y2: "44.8209184%",
    id: "linearGradient-149"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1960.82143%",
    y1: "68.6738494%",
    x2: "381.082143%",
    y2: "53.2916318%",
    id: "linearGradient-150"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1801.2352%",
    y1: "58.2696939%",
    x2: "221.495918%",
    y2: "50.7669388%",
    id: "linearGradient-151"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1647.73316%",
    y1: "65.6225941%",
    x2: "67.9933673%",
    y2: "50.2403766%",
    id: "linearGradient-152"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1488.01954%",
    y1: "56.7814286%",
    x2: "-91.5850474%",
    y2: "49.2786735%",
    id: "linearGradient-153"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1334.13418%",
    y1: "62.5713389%",
    x2: "-245.605102%",
    y2: "47.1893305%",
    id: "linearGradient-154"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1174.54796%",
    y1: "55.2931633%",
    x2: "-405.191837%",
    y2: "47.7905102%",
    id: "linearGradient-155"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1021.04541%",
    y1: "59.5200837%",
    x2: "-558.693878%",
    y2: "44.1378661%",
    id: "linearGradient-156"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "860.94898%",
    y1: "53.804898%",
    x2: "-718.790306%",
    y2: "46.3021429%",
    id: "linearGradient-157"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "707.446429%",
    y1: "56.4688285%",
    x2: "-872.292857%",
    y2: "41.0868201%",
    id: "linearGradient-158"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1954.31735%",
    y1: "73.2065104%",
    x2: "374.577551%",
    y2: "54.0591146%",
    id: "linearGradient-159"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1641.22857%",
    y1: "69.4083333%",
    x2: "61.4892857%",
    y2: "50.2609375%",
    id: "linearGradient-160"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1327.62959%",
    y1: "65.6104167%",
    x2: "-252.109694%",
    y2: "46.4627604%",
    id: "linearGradient-161"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1014.54133%",
    y1: "61.8119792%",
    x2: "-565.198469%",
    y2: "42.6645833%",
    id: "linearGradient-162"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "700.942347%",
    y1: "58.0140625%",
    x2: "-878.796939%",
    y2: "38.8664063%",
    id: "linearGradient-163"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2028.08265%",
    y1: "59.8316327%",
    x2: "-448.343367%",
    y2: "52.3288776%",
    id: "linearGradient-164"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1871.37016%",
    y1: "59.087449%",
    x2: "-291.765572%",
    y2: "51.5846939%",
    id: "linearGradient-165"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1714.48367%",
    y1: "58.3433673%",
    x2: "-134.744388%",
    y2: "50.8406122%",
    id: "linearGradient-166"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1557.9398%",
    y1: "57.5991837%",
    x2: "21.8%",
    y2: "50.0965306%",
    id: "linearGradient-167"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1401.39541%",
    y1: "56.855102%",
    x2: "178.344388%",
    y2: "49.3523469%",
    id: "linearGradient-168"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1244.34082%",
    y1: "56.1109184%",
    x2: "335.398469%",
    y2: "48.6082653%",
    id: "linearGradient-169"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1087.79643%",
    y1: "55.3668367%",
    x2: "491.942857%",
    y2: "47.8640816%",
    id: "linearGradient-170"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-931.252041%",
    y1: "54.6226531%",
    x2: "648.487245%",
    y2: "47.12%",
    id: "linearGradient-171"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-774.707653%",
    y1: "53.8785714%",
    x2: "805.031633%",
    y2: "46.3758163%",
    id: "linearGradient-172"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-617.653571%",
    y1: "53.1343878%",
    x2: "962.086224%",
    y2: "45.6317347%",
    id: "linearGradient-173"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2014.72806%",
    y1: "59.7579592%",
    x2: "-434.988265%",
    y2: "52.2552041%",
    id: "linearGradient-174"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-462.638776%",
    y1: "52.3972449%",
    x2: "1117.10051%",
    y2: "44.8945918%",
    id: "linearGradient-175"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-449.284184%",
    y1: "52.3236735%",
    x2: "1130.45561%",
    y2: "44.8209184%",
    id: "linearGradient-176"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1861.05828%",
    y1: "68.6738494%",
    x2: "-281.453697%",
    y2: "53.2916318%",
    id: "linearGradient-177"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1701.12908%",
    y1: "58.2696939%",
    x2: "-121.389286%",
    y2: "50.7669388%",
    id: "linearGradient-178"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1547.62653%",
    y1: "65.6225941%",
    x2: "32.1127551%",
    y2: "50.2403766%",
    id: "linearGradient-179"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1388.04082%",
    y1: "56.7814286%",
    x2: "191.69898%",
    y2: "49.2786735%",
    id: "linearGradient-180"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1234.02806%",
    y1: "62.5713389%",
    x2: "345.711735%",
    y2: "47.1893305%",
    id: "linearGradient-181"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1074.44184%",
    y1: "55.2931633%",
    x2: "505.297959%",
    y2: "47.7905102%",
    id: "linearGradient-182"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-920.939286%",
    y1: "59.5200837%",
    x2: "658.8%",
    y2: "44.1378661%",
    id: "linearGradient-183"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-761.353061%",
    y1: "53.804898%",
    x2: "818.386224%",
    y2: "46.3021429%",
    id: "linearGradient-184"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-607.340816%",
    y1: "56.4688285%",
    x2: "972.39898%",
    y2: "41.0868201%",
    id: "linearGradient-185"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1854.55476%",
    y1: "73.2065104%",
    x2: "-274.949659%",
    y2: "54.0591146%",
    id: "linearGradient-186"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1541.12245%",
    y1: "69.4085938%",
    x2: "38.6173469%",
    y2: "50.2609375%",
    id: "linearGradient-187"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1227.52347%",
    y1: "65.6104167%",
    x2: "352.215816%",
    y2: "46.4627604%",
    id: "linearGradient-188"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-914.434694%",
    y1: "61.8122396%",
    x2: "665.304592%",
    y2: "42.6645833%",
    id: "linearGradient-189"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-600.836224%",
    y1: "58.0140625%",
    x2: "978.903571%",
    y2: "38.8664063%",
    id: "linearGradient-190"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2127.94439%",
    y1: "59.8871429%",
    x2: "548.205102%",
    y2: "52.3844898%",
    id: "linearGradient-191"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1971.40051%",
    y1: "59.1430612%",
    x2: "391.661224%",
    y2: "51.6403061%",
    id: "linearGradient-192"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1814.70138%",
    y1: "58.3988776%",
    x2: "235.096789%",
    y2: "50.8962245%",
    id: "linearGradient-193"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1657.80153%",
    y1: "57.6547959%",
    x2: "78.0622449%",
    y2: "50.1520408%",
    id: "linearGradient-194"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1501.25765%",
    y1: "56.9106122%",
    x2: "-78.4821429%",
    y2: "49.4079592%",
    id: "linearGradient-195"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1344.71327%",
    y1: "56.1665306%",
    x2: "-235.026531%",
    y2: "48.6637755%",
    id: "linearGradient-196"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1187.65867%",
    y1: "55.4223469%",
    x2: "-392.080612%",
    y2: "47.9196939%",
    id: "linearGradient-197"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1031.11378%",
    y1: "54.6782653%",
    x2: "-548.62551%",
    y2: "47.1755102%",
    id: "linearGradient-198"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "874.569898%",
    y1: "53.9340816%",
    x2: "-705.169388%",
    y2: "46.4314286%",
    id: "linearGradient-199"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "718.02551%",
    y1: "53.19%",
    x2: "-861.713776%",
    y2: "45.6872449%",
    id: "linearGradient-200"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2114.5898%",
    y1: "59.8135714%",
    x2: "534.85051%",
    y2: "52.3108163%",
    id: "linearGradient-201"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "562.50102%",
    y1: "52.4528571%",
    x2: "-1017.23827%",
    y2: "44.950102%",
    id: "linearGradient-202"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "549.146429%",
    y1: "52.3791837%",
    x2: "-1030.59337%",
    y2: "44.8765306%",
    id: "linearGradient-203"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1961.08776%",
    y1: "68.5784519%",
    x2: "381.347959%",
    y2: "53.1964435%",
    id: "linearGradient-204"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1801.34741%",
    y1: "58.3253061%",
    x2: "221.742826%",
    y2: "50.822551%",
    id: "linearGradient-205"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1647.48878%",
    y1: "65.5274059%",
    x2: "67.7494898%",
    y2: "50.1451883%",
    id: "linearGradient-206"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1487.90255%",
    y1: "56.8370408%",
    x2: "-91.8372449%",
    y2: "49.3342857%",
    id: "linearGradient-207"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1334.4%",
    y1: "62.4761506%",
    x2: "-245.339286%",
    y2: "47.0939331%",
    id: "linearGradient-208"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1174.30408%",
    y1: "55.3487755%",
    x2: "-405.435714%",
    y2: "47.8460204%",
    id: "linearGradient-209"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1020.80153%",
    y1: "59.4248954%",
    x2: "-558.938265%",
    y2: "44.0426778%",
    id: "linearGradient-210"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "861.214796%",
    y1: "53.8605102%",
    x2: "-718.52449%",
    y2: "46.3577551%",
    id: "linearGradient-211"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "707.712245%",
    y1: "56.3736402%",
    x2: "-872.027041%",
    y2: "40.9914226%",
    id: "linearGradient-212"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1954.58316%",
    y1: "73.0880208%",
    x2: "374.843367%",
    y2: "53.9403646%",
    id: "linearGradient-213"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1640.98469%",
    y1: "69.2898438%",
    x2: "61.244898%",
    y2: "50.1421875%",
    id: "linearGradient-214"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1327.89541%",
    y1: "65.4916667%",
    x2: "-251.843878%",
    y2: "46.3442708%",
    id: "linearGradient-215"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1014.29694%",
    y1: "61.6934896%",
    x2: "-565.442347%",
    y2: "42.5458333%",
    id: "linearGradient-216"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "701.208673%",
    y1: "57.8953125%",
    x2: "-878.531122%",
    y2: "38.7479167%",
    id: "linearGradient-217"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2128.18878%",
    y1: "59.8871429%",
    x2: "548.44949%",
    y2: "52.3844898%",
    id: "linearGradient-218"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1971.13469%",
    y1: "59.1430612%",
    x2: "391.394898%",
    y2: "51.6403061%",
    id: "linearGradient-219"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1814.59031%",
    y1: "58.3988776%",
    x2: "234.85051%",
    y2: "50.8962245%",
    id: "linearGradient-220"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1658.04592%",
    y1: "57.6547959%",
    x2: "78.3066327%",
    y2: "50.1520408%",
    id: "linearGradient-221"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1501.3735%",
    y1: "56.9106122%",
    x2: "-78.2315942%",
    y2: "49.4079592%",
    id: "linearGradient-222"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1344.44694%",
    y1: "56.1665306%",
    x2: "-235.292347%",
    y2: "48.6637755%",
    id: "linearGradient-223"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1187.90306%",
    y1: "55.4223469%",
    x2: "-391.836735%",
    y2: "47.9196939%",
    id: "linearGradient-224"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1031.35816%",
    y1: "54.6782653%",
    x2: "-548.381122%",
    y2: "47.1755102%",
    id: "linearGradient-225"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "874.304082%",
    y1: "53.9340816%",
    x2: "-705.435714%",
    y2: "46.4314286%",
    id: "linearGradient-226"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "717.759694%",
    y1: "53.19%",
    x2: "-861.980102%",
    y2: "45.6872449%",
    id: "linearGradient-227"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2114.83418%",
    y1: "59.8135714%",
    x2: "535.094898%",
    y2: "52.3108163%",
    id: "linearGradient-228"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "562.745408%",
    y1: "52.4528571%",
    x2: "-1016.99439%",
    y2: "44.950102%",
    id: "linearGradient-229"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "549.390306%",
    y1: "52.3791837%",
    x2: "-1030.34949%",
    y2: "44.8765306%",
    id: "linearGradient-230"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1960.82143%",
    y1: "68.5784519%",
    x2: "381.082143%",
    y2: "53.1964435%",
    id: "linearGradient-231"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1801.2352%",
    y1: "58.3253061%",
    x2: "221.495918%",
    y2: "50.822551%",
    id: "linearGradient-232"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1647.73316%",
    y1: "65.5274059%",
    x2: "67.9933673%",
    y2: "50.1451883%",
    id: "linearGradient-233"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1488.01954%",
    y1: "56.8370408%",
    x2: "-91.5850474%",
    y2: "49.3342857%",
    id: "linearGradient-234"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1334.13418%",
    y1: "62.4761506%",
    x2: "-245.605102%",
    y2: "47.0939331%",
    id: "linearGradient-235"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1174.54796%",
    y1: "55.3487755%",
    x2: "-405.191837%",
    y2: "47.8460204%",
    id: "linearGradient-236"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1021.04541%",
    y1: "59.4248954%",
    x2: "-558.693878%",
    y2: "44.0426778%",
    id: "linearGradient-237"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "860.94898%",
    y1: "53.8605102%",
    x2: "-718.790306%",
    y2: "46.3577551%",
    id: "linearGradient-238"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "707.446429%",
    y1: "56.3736402%",
    x2: "-872.292857%",
    y2: "40.9914226%",
    id: "linearGradient-239"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1954.31735%",
    y1: "73.0880208%",
    x2: "374.577551%",
    y2: "53.9403646%",
    id: "linearGradient-240"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1641.22857%",
    y1: "69.2898438%",
    x2: "61.4892857%",
    y2: "50.1421875%",
    id: "linearGradient-241"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1327.62959%",
    y1: "65.4916667%",
    x2: "-252.109694%",
    y2: "46.3442708%",
    id: "linearGradient-242"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1014.54133%",
    y1: "61.6934896%",
    x2: "-565.198469%",
    y2: "42.5458333%",
    id: "linearGradient-243"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "700.942347%",
    y1: "57.8953125%",
    x2: "-878.796939%",
    y2: "38.7479167%",
    id: "linearGradient-244"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2028.08265%",
    y1: "59.8871429%",
    x2: "-448.343367%",
    y2: "52.3844898%",
    id: "linearGradient-245"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1871.37016%",
    y1: "59.1430612%",
    x2: "-291.765572%",
    y2: "51.6403061%",
    id: "linearGradient-246"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1714.48367%",
    y1: "58.3988776%",
    x2: "-134.744388%",
    y2: "50.8962245%",
    id: "linearGradient-247"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1557.9398%",
    y1: "57.6547959%",
    x2: "21.8%",
    y2: "50.1520408%",
    id: "linearGradient-248"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1401.39541%",
    y1: "56.9106122%",
    x2: "178.344388%",
    y2: "49.4079592%",
    id: "linearGradient-249"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1244.34082%",
    y1: "56.1665306%",
    x2: "335.398469%",
    y2: "48.6637755%",
    id: "linearGradient-250"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1087.79643%",
    y1: "55.4223469%",
    x2: "491.942857%",
    y2: "47.9196939%",
    id: "linearGradient-251"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-931.252041%",
    y1: "54.6782653%",
    x2: "648.487245%",
    y2: "47.1755102%",
    id: "linearGradient-252"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-774.707653%",
    y1: "53.9340816%",
    x2: "805.031633%",
    y2: "46.4314286%",
    id: "linearGradient-253"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-617.653571%",
    y1: "53.19%",
    x2: "962.086224%",
    y2: "45.6872449%",
    id: "linearGradient-254"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2014.72806%",
    y1: "59.8135714%",
    x2: "-434.988265%",
    y2: "52.3108163%",
    id: "linearGradient-255"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-462.638776%",
    y1: "52.4528571%",
    x2: "1117.10051%",
    y2: "44.950102%",
    id: "linearGradient-256"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-449.284184%",
    y1: "52.3791837%",
    x2: "1130.45561%",
    y2: "44.8765306%",
    id: "linearGradient-257"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1861.05828%",
    y1: "68.5784519%",
    x2: "-281.453697%",
    y2: "53.1964435%",
    id: "linearGradient-258"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1701.12908%",
    y1: "58.3253061%",
    x2: "-121.389286%",
    y2: "50.822551%",
    id: "linearGradient-259"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1547.62653%",
    y1: "65.5274059%",
    x2: "32.1127551%",
    y2: "50.1451883%",
    id: "linearGradient-260"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1388.04082%",
    y1: "56.8370408%",
    x2: "191.69898%",
    y2: "49.3342857%",
    id: "linearGradient-261"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1234.02806%",
    y1: "62.4761506%",
    x2: "345.711735%",
    y2: "47.0939331%",
    id: "linearGradient-262"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1074.44184%",
    y1: "55.3487755%",
    x2: "505.297959%",
    y2: "47.8460204%",
    id: "linearGradient-263"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-920.939286%",
    y1: "59.4248954%",
    x2: "658.8%",
    y2: "44.0426778%",
    id: "linearGradient-264"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-761.353061%",
    y1: "53.8605102%",
    x2: "818.386224%",
    y2: "46.3577551%",
    id: "linearGradient-265"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-607.340816%",
    y1: "56.3736402%",
    x2: "972.39898%",
    y2: "40.9914226%",
    id: "linearGradient-266"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1854.55476%",
    y1: "73.0880208%",
    x2: "-274.949659%",
    y2: "53.9403646%",
    id: "linearGradient-267"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1541.12245%",
    y1: "69.2898438%",
    x2: "38.6173469%",
    y2: "50.1421875%",
    id: "linearGradient-268"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1227.52347%",
    y1: "65.4916667%",
    x2: "352.215816%",
    y2: "46.3442708%",
    id: "linearGradient-269"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-914.434694%",
    y1: "61.6934896%",
    x2: "665.304592%",
    y2: "42.5458333%",
    id: "linearGradient-270"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-600.836224%",
    y1: "57.8953125%",
    x2: "978.903571%",
    y2: "38.7479167%",
    id: "linearGradient-271"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.979192%",
    y1: "0.00419161677%",
    x2: "49.979192%",
    y2: "99.9872255%",
    id: "linearGradient-272"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFE",
    offset: "86.08%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9899774%",
    y1: "-0.0956087824%",
    x2: "49.9899774%",
    y2: "99.8874251%",
    id: "linearGradient-273"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFE",
    offset: "86.08%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9991235%",
    y1: "-0.00313075506%",
    x2: "49.9991235%",
    y2: "99.9767956%",
    id: "linearGradient-274"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFE",
    offset: "86.08%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9802452%",
    y1: "-0.00313075506%",
    x2: "49.9802452%",
    y2: "99.9767956%",
    id: "linearGradient-275"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFE",
    offset: "86.08%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9952938%",
    y1: "99.9994777%",
    x2: "49.9952938%",
    y2: "-0.00414558512%",
    id: "linearGradient-276"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD9E8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0304166667%",
    y1: "50.0862592%",
    x2: "100.010417%",
    y2: "50.0862592%",
    id: "linearGradient-277"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCADE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-10.8866574%",
    y1: "34.1940106%",
    x2: "101.840028%",
    y2: "60.3878438%",
    id: "linearGradient-278"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCADE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.6494926%",
    y1: "71.1983128%",
    x2: "53.7791102%",
    y2: "33.9052225%",
    id: "linearGradient-279"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCADE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.18092441%",
    y1: "54.0515282%",
    x2: "103.979501%",
    y2: "46.7323215%",
    id: "linearGradient-280"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCADE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.8895648%",
    y1: "50.5712328%",
    x2: "-0.65044201%",
    y2: "49.3663657%",
    id: "linearGradient-281"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCADE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9967321%",
    y1: "100.001092%",
    x2: "49.9967321%",
    y2: "0.00451510334%",
    id: "linearGradient-282"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "56.66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0.5,
    offset: "96.67%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Playground",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "han-bear"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.5,957.1 C170.5,699.9 379,491.4 636.2,491.4 C893.4,491.4 1101.9,699.9 1101.9,957.1",
    id: "Shape",
    fill: "url(#radialGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(808.000000, 699.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,98.2 C5,98.2 0.6,93.8 0.6,88.4 L0.6,10 C0.6,4.6 5,0.2 10.4,0.2 C15.8,0.2 20.2,4.6 20.2,10 L20.2,88.4 C20.2,93.8 15.8,98.2 10.4,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,98.2 C35.7,98.2 31.3,93.8 31.3,88.4 L31.3,10 C31.3,4.6 35.7,0.2 41.1,0.2 C46.5,0.2 50.9,4.6 50.9,10 L50.9,88.4 C50.9,93.8 46.5,98.2 41.1,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,98.2 C66.4,98.2 62,93.8 62,88.4 L62,10 C62,4.6 66.4,0.2 71.8,0.2 C77.2,0.2 81.6,4.6 81.6,10 L81.6,88.4 C81.7,93.8 77.3,98.2 71.8,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,98.2 C97.2,98.2 92.8,93.8 92.8,88.4 L92.8,10 C92.8,4.6 97.2,0.2 102.6,0.2 C108,0.2 112.4,4.6 112.4,10 L112.4,88.4 C112.4,93.8 108,98.2 102.6,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,98.2 C127.9,98.2 123.5,93.8 123.5,88.4 L123.5,10 C123.5,4.6 127.9,0.2 133.3,0.2 C138.7,0.2 143.1,4.6 143.1,10 L143.1,88.4 C143.1,93.8 138.7,98.2 133.3,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,98.2 C158.6,98.2 154.2,93.8 154.2,88.4 L154.2,10 C154.2,4.6 158.6,0.2 164,0.2 C169.4,0.2 173.8,4.6 173.8,10 L173.8,88.4 C173.8,93.8 169.4,98.2 164,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,98.2 C189.4,98.2 185,93.8 185,88.4 L185,10 C185,4.6 189.4,0.2 194.8,0.2 C200.2,0.2 204.6,4.6 204.6,10 L204.6,88.4 C204.6,93.8 200.2,98.2 194.8,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,98.2 C220.1,98.2 215.7,93.8 215.7,88.4 L215.7,10 C215.7,4.6 220.1,0.2 225.5,0.2 C230.9,0.2 235.3,4.6 235.3,10 L235.3,88.4 C235.3,93.8 230.9,98.2 225.5,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,98.2 C250.8,98.2 246.4,93.8 246.4,88.4 L246.4,10 C246.4,4.6 250.8,0.2 256.2,0.2 C261.6,0.2 266,4.6 266,10 L266,88.4 C266,93.8 261.6,98.2 256.2,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,98.2 C281.5,98.2 277.1,93.8 277.1,88.4 L277.1,10 C277.1,4.6 281.5,0.2 286.9,0.2 C292.3,0.2 296.7,4.6 296.7,10 L296.7,88.4 C296.7,93.8 292.3,98.2 286.9,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,208.5 C5,208.5 0.6,204.1 0.6,198.7 L0.6,120.3 C0.6,114.9 5,110.5 10.4,110.5 C15.8,110.5 20.2,114.9 20.2,120.3 L20.2,198.7 C20.2,204.1 15.8,208.5 10.4,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,98.2 C312,98.2 307.6,93.8 307.6,88.4 L307.6,10 C307.6,4.6 312,0.2 317.4,0.2 C322.8,0.2 327.2,4.6 327.2,10 L327.2,88.4 C327.2,93.8 322.8,98.2 317.4,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,208.5 C312,208.5 307.6,204.1 307.6,198.7 L307.6,120.3 C307.6,114.9 312,110.5 317.4,110.5 C322.8,110.5 327.2,114.9 327.2,120.3 L327.2,198.7 C327.2,204.1 322.8,208.5 317.4,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,158.2 C35.7,158.2 31.3,153.8 31.3,148.4 L31.3,120.2 C31.3,114.8 35.7,110.4 41.1,110.4 C46.5,110.4 50.9,114.8 50.9,120.2 L50.9,148.4 C50.9,153.8 46.5,158.2 41.1,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,208.5 C66.4,208.5 62,204.1 62,198.7 L62,120.3 C62,114.9 66.4,110.5 71.8,110.5 C77.2,110.5 81.6,114.9 81.6,120.3 L81.6,198.7 C81.7,204.1 77.3,208.5 71.8,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,158.2 C97.2,158.2 92.8,153.8 92.8,148.4 L92.8,120.2 C92.8,114.8 97.2,110.4 102.6,110.4 C108,110.4 112.4,114.8 112.4,120.2 L112.4,148.4 C112.4,153.8 108,158.2 102.6,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,208.5 C127.9,208.5 123.5,204.1 123.5,198.7 L123.5,120.3 C123.5,114.9 127.9,110.5 133.3,110.5 C138.7,110.5 143.1,114.9 143.1,120.3 L143.1,198.7 C143.1,204.1 138.7,208.5 133.3,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,158.2 C158.6,158.2 154.2,153.8 154.2,148.4 L154.2,120.2 C154.2,114.8 158.6,110.4 164,110.4 C169.4,110.4 173.8,114.8 173.8,120.2 L173.8,148.4 C173.8,153.8 169.4,158.2 164,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,208.5 C189.4,208.5 185,204.1 185,198.7 L185,120.3 C185,114.9 189.4,110.5 194.8,110.5 C200.2,110.5 204.6,114.9 204.6,120.3 L204.6,198.7 C204.6,204.1 200.2,208.5 194.8,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,158.2 C220.1,158.2 215.7,153.8 215.7,148.4 L215.7,120.2 C215.7,114.8 220.1,110.4 225.5,110.4 C230.9,110.4 235.3,114.8 235.3,120.2 L235.3,148.4 C235.3,153.8 230.9,158.2 225.5,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,208.5 C250.8,208.5 246.4,204.1 246.4,198.7 L246.4,120.3 C246.4,114.9 250.8,110.5 256.2,110.5 C261.6,110.5 266,114.9 266,120.3 L266,198.7 C266,204.1 261.6,208.5 256.2,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,158.2 C281.5,158.2 277.1,153.8 277.1,148.4 L277.1,120.2 C277.1,114.8 281.5,110.4 286.9,110.4 C292.3,110.4 296.7,114.8 296.7,120.2 L296.7,148.4 C296.7,153.8 292.3,158.2 286.9,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,207.2 C35.7,207.2 31.3,202.8 31.3,197.4 L31.3,178.6 C31.3,173.2 35.7,168.8 41.1,168.8 C46.5,168.8 50.9,173.2 50.9,178.6 L50.9,197.4 C50.9,202.8 46.5,207.2 41.1,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,207.2 C97.2,207.2 92.8,202.8 92.8,197.4 L92.8,178.6 C92.8,173.2 97.2,168.8 102.6,168.8 C108,168.8 112.4,173.2 112.4,178.6 L112.4,197.4 C112.4,202.8 108,207.2 102.6,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,207.2 C158.6,207.2 154.2,202.8 154.2,197.4 L154.2,178.6 C154.2,173.2 158.6,168.8 164,168.8 C169.4,168.8 173.8,173.2 173.8,178.6 L173.8,197.4 C173.8,202.8 169.4,207.2 164,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,207.2 C220.1,207.2 215.7,202.8 215.7,197.4 L215.7,178.6 C215.7,173.2 220.1,168.8 225.5,168.8 C230.9,168.8 235.3,173.2 235.3,178.6 L235.3,197.4 C235.3,202.8 230.9,207.2 225.5,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,207.2 C281.5,207.2 277.1,202.8 277.1,197.4 L277.1,178.6 C277.1,173.2 281.5,168.8 286.9,168.8 C292.3,168.8 296.7,173.2 296.7,178.6 L296.7,197.4 C296.7,202.8 292.3,207.2 286.9,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(128.000000, 699.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.9,98.2 C322.3,98.2 326.7,93.8 326.7,88.4 L326.7,10 C326.7,4.6 322.3,0.2 316.9,0.2 C311.5,0.2 307.1,4.6 307.1,10 L307.1,88.4 C307.1,93.8 311.5,98.2 316.9,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,98.2 C291.6,98.2 296,93.8 296,88.4 L296,10 C296,4.6 291.6,0.2 286.2,0.2 C280.8,0.2 276.4,4.6 276.4,10 L276.4,88.4 C276.3,93.8 280.7,98.2 286.2,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,98.2 C260.8,98.2 265.2,93.8 265.2,88.4 L265.2,10 C265.2,4.6 260.8,0.2 255.4,0.2 C250,0.2 245.6,4.6 245.6,10 L245.6,88.4 C245.6,93.8 250,98.2 255.4,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,98.2 C230.1,98.2 234.5,93.8 234.5,88.4 L234.5,10 C234.5,4.6 230.1,0.2 224.7,0.2 C219.3,0.2 214.9,4.6 214.9,10 L214.9,88.4 C214.9,93.8 219.3,98.2 224.7,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,98.2 C199.4,98.2 203.8,93.8 203.8,88.4 L203.8,10 C203.8,4.6 199.4,0.2 194,0.2 C188.6,0.2 184.2,4.6 184.2,10 L184.2,88.4 C184.2,93.8 188.6,98.2 194,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,98.2 C168.6,98.2 173,93.8 173,88.4 L173,10 C173,4.6 168.6,0.2 163.2,0.2 C157.8,0.2 153.4,4.6 153.4,10 L153.4,88.4 C153.4,93.8 157.8,98.2 163.2,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,98.2 C137.9,98.2 142.3,93.8 142.3,88.4 L142.3,10 C142.3,4.6 137.9,0.2 132.5,0.2 C127.1,0.2 122.7,4.6 122.7,10 L122.7,88.4 C122.7,93.8 127.1,98.2 132.5,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,98.2 C107.2,98.2 111.6,93.8 111.6,88.4 L111.6,10 C111.6,4.6 107.2,0.2 101.8,0.2 C96.4,0.2 92,4.6 92,10 L92,88.4 C92,93.8 96.4,98.2 101.8,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,98.2 C76.5,98.2 80.9,93.8 80.9,88.4 L80.9,10 C80.9,4.6 76.5,0.2 71.1,0.2 C65.7,0.2 61.3,4.6 61.3,10 L61.3,88.4 C61.3,93.8 65.7,98.2 71.1,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,98.2 C45.7,98.2 50.1,93.8 50.1,88.4 L50.1,10 C50.1,4.6 45.7,0.2 40.3,0.2 C34.9,0.2 30.5,4.6 30.5,10 L30.5,88.4 C30.5,93.8 34.9,98.2 40.3,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9,208.5 C322.3,208.5 326.7,204.1 326.7,198.7 L326.7,120.3 C326.7,114.9 322.3,110.5 316.9,110.5 C311.5,110.5 307.1,114.9 307.1,120.3 L307.1,198.7 C307.1,204.1 311.5,208.5 316.9,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,98.2 C15.3,98.2 19.7,93.8 19.7,88.4 L19.7,10 C19.7,4.6 15.3,0.2 9.9,0.2 C4.5,0.2 0.1,4.6 0.1,10 L0.1,88.4 C0.1,93.8 4.5,98.2 9.9,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,208.5 C15.3,208.5 19.7,204.1 19.7,198.7 L19.7,120.3 C19.7,114.9 15.3,110.5 9.9,110.5 C4.5,110.5 0.1,114.9 0.1,120.3 L0.1,198.7 C0.1,204.1 4.5,208.5 9.9,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,158.2 C291.6,158.2 296,153.8 296,148.4 L296,120.2 C296,114.8 291.6,110.4 286.2,110.4 C280.8,110.4 276.4,114.8 276.4,120.2 L276.4,148.4 C276.3,153.8 280.7,158.2 286.2,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,208.5 C260.8,208.5 265.2,204.1 265.2,198.7 L265.2,120.3 C265.2,114.9 260.8,110.5 255.4,110.5 C250,110.5 245.6,114.9 245.6,120.3 L245.6,198.7 C245.6,204.1 250,208.5 255.4,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,158.2 C230.1,158.2 234.5,153.8 234.5,148.4 L234.5,120.2 C234.5,114.8 230.1,110.4 224.7,110.4 C219.3,110.4 214.9,114.8 214.9,120.2 L214.9,148.4 C214.9,153.8 219.3,158.2 224.7,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,208.5 C199.4,208.5 203.8,204.1 203.8,198.7 L203.8,120.3 C203.8,114.9 199.4,110.5 194,110.5 C188.6,110.5 184.2,114.9 184.2,120.3 L184.2,198.7 C184.2,204.1 188.6,208.5 194,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,158.2 C168.6,158.2 173,153.8 173,148.4 L173,120.2 C173,114.8 168.6,110.4 163.2,110.4 C157.8,110.4 153.4,114.8 153.4,120.2 L153.4,148.4 C153.4,153.8 157.8,158.2 163.2,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,208.5 C137.9,208.5 142.3,204.1 142.3,198.7 L142.3,120.3 C142.3,114.9 137.9,110.5 132.5,110.5 C127.1,110.5 122.7,114.9 122.7,120.3 L122.7,198.7 C122.7,204.1 127.1,208.5 132.5,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,158.2 C107.2,158.2 111.6,153.8 111.6,148.4 L111.6,120.2 C111.6,114.8 107.2,110.4 101.8,110.4 C96.4,110.4 92,114.8 92,120.2 L92,148.4 C92,153.8 96.4,158.2 101.8,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,208.5 C76.5,208.5 80.9,204.1 80.9,198.7 L80.9,120.3 C80.9,114.9 76.5,110.5 71.1,110.5 C65.7,110.5 61.3,114.9 61.3,120.3 L61.3,198.7 C61.3,204.1 65.7,208.5 71.1,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,158.2 C45.7,158.2 50.1,153.8 50.1,148.4 L50.1,120.2 C50.1,114.8 45.7,110.4 40.3,110.4 C34.9,110.4 30.5,114.8 30.5,120.2 L30.5,148.4 C30.5,153.8 34.9,158.2 40.3,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,207.2 C291.6,207.2 296,202.8 296,197.4 L296,178.6 C296,173.2 291.6,168.8 286.2,168.8 C280.8,168.8 276.4,173.2 276.4,178.6 L276.4,197.4 C276.3,202.8 280.7,207.2 286.2,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,207.2 C230.1,207.2 234.5,202.8 234.5,197.4 L234.5,178.6 C234.5,173.2 230.1,168.8 224.7,168.8 C219.3,168.8 214.9,173.2 214.9,178.6 L214.9,197.4 C214.9,202.8 219.3,207.2 224.7,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,207.2 C168.6,207.2 173,202.8 173,197.4 L173,178.6 C173,173.2 168.6,168.8 163.2,168.8 C157.8,168.8 153.4,173.2 153.4,178.6 L153.4,197.4 C153.4,202.8 157.8,207.2 163.2,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,207.2 C107.2,207.2 111.6,202.8 111.6,197.4 L111.6,178.6 C111.6,173.2 107.2,168.8 101.8,168.8 C96.4,168.8 92,173.2 92,178.6 L92,197.4 C92,202.8 96.4,207.2 101.8,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,207.2 C45.7,207.2 50.1,202.8 50.1,197.4 L50.1,178.6 C50.1,173.2 45.7,168.8 40.3,168.8 C34.9,168.8 30.5,173.2 30.5,178.6 L30.5,197.4 C30.5,202.8 34.9,207.2 40.3,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-55)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(808.000000, 466.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,98.3 C5,98.3 0.6,93.9 0.6,88.5 L0.6,10.1 C0.6,4.7 5,0.3 10.4,0.3 C15.8,0.3 20.2,4.7 20.2,10.1 L20.2,88.5 C20.2,93.9 15.8,98.3 10.4,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,98.3 C35.7,98.3 31.3,93.9 31.3,88.5 L31.3,10.1 C31.3,4.7 35.7,0.3 41.1,0.3 C46.5,0.3 50.9,4.7 50.9,10.1 L50.9,88.5 C50.9,93.9 46.5,98.3 41.1,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,98.3 C66.4,98.3 62,93.9 62,88.5 L62,10.1 C62,4.7 66.4,0.3 71.8,0.3 C77.2,0.3 81.6,4.7 81.6,10.1 L81.6,88.5 C81.7,93.9 77.3,98.3 71.8,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,98.3 C97.2,98.3 92.8,93.9 92.8,88.5 L92.8,10.1 C92.8,4.7 97.2,0.3 102.6,0.3 C108,0.3 112.4,4.7 112.4,10.1 L112.4,88.5 C112.4,93.9 108,98.3 102.6,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,98.3 C127.9,98.3 123.5,93.9 123.5,88.5 L123.5,10.1 C123.5,4.7 127.9,0.3 133.3,0.3 C138.7,0.3 143.1,4.7 143.1,10.1 L143.1,88.5 C143.1,93.9 138.7,98.3 133.3,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,98.3 C158.6,98.3 154.2,93.9 154.2,88.5 L154.2,10.1 C154.2,4.7 158.6,0.3 164,0.3 C169.4,0.3 173.8,4.7 173.8,10.1 L173.8,88.5 C173.8,93.9 169.4,98.3 164,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,98.3 C189.4,98.3 185,93.9 185,88.5 L185,10.1 C185,4.7 189.4,0.3 194.8,0.3 C200.2,0.3 204.6,4.7 204.6,10.1 L204.6,88.5 C204.6,93.9 200.2,98.3 194.8,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,98.3 C220.1,98.3 215.7,93.9 215.7,88.5 L215.7,10.1 C215.7,4.7 220.1,0.3 225.5,0.3 C230.9,0.3 235.3,4.7 235.3,10.1 L235.3,88.5 C235.3,93.9 230.9,98.3 225.5,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,98.3 C250.8,98.3 246.4,93.9 246.4,88.5 L246.4,10.1 C246.4,4.7 250.8,0.3 256.2,0.3 C261.6,0.3 266,4.7 266,10.1 L266,88.5 C266,93.9 261.6,98.3 256.2,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,98.3 C281.5,98.3 277.1,93.9 277.1,88.5 L277.1,10.1 C277.1,4.7 281.5,0.3 286.9,0.3 C292.3,0.3 296.7,4.7 296.7,10.1 L296.7,88.5 C296.7,93.9 292.3,98.3 286.9,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,208.6 C5,208.6 0.6,204.2 0.6,198.8 L0.6,120.4 C0.6,115 5,110.6 10.4,110.6 C15.8,110.6 20.2,115 20.2,120.4 L20.2,198.8 C20.2,204.2 15.8,208.6 10.4,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,98.3 C312,98.3 307.6,93.9 307.6,88.5 L307.6,10.1 C307.6,4.7 312,0.3 317.4,0.3 C322.8,0.3 327.2,4.7 327.2,10.1 L327.2,88.5 C327.2,93.9 322.8,98.3 317.4,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,208.6 C312,208.6 307.6,204.2 307.6,198.8 L307.6,120.4 C307.6,115 312,110.6 317.4,110.6 C322.8,110.6 327.2,115 327.2,120.4 L327.2,198.8 C327.2,204.2 322.8,208.6 317.4,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,158.4 C35.7,158.4 31.3,154 31.3,148.6 L31.3,120.4 C31.3,115 35.7,110.6 41.1,110.6 C46.5,110.6 50.9,115 50.9,120.4 L50.9,148.6 C50.9,154 46.5,158.4 41.1,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,208.6 C66.4,208.6 62,204.2 62,198.8 L62,120.4 C62,115 66.4,110.6 71.8,110.6 C77.2,110.6 81.6,115 81.6,120.4 L81.6,198.8 C81.7,204.2 77.3,208.6 71.8,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,158.4 C97.2,158.4 92.8,154 92.8,148.6 L92.8,120.4 C92.8,115 97.2,110.6 102.6,110.6 C108,110.6 112.4,115 112.4,120.4 L112.4,148.6 C112.4,154 108,158.4 102.6,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,208.6 C127.9,208.6 123.5,204.2 123.5,198.8 L123.5,120.4 C123.5,115 127.9,110.6 133.3,110.6 C138.7,110.6 143.1,115 143.1,120.4 L143.1,198.8 C143.1,204.2 138.7,208.6 133.3,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,158.4 C158.6,158.4 154.2,154 154.2,148.6 L154.2,120.4 C154.2,115 158.6,110.6 164,110.6 C169.4,110.6 173.8,115 173.8,120.4 L173.8,148.6 C173.8,154 169.4,158.4 164,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,208.6 C189.4,208.6 185,204.2 185,198.8 L185,120.4 C185,115 189.4,110.6 194.8,110.6 C200.2,110.6 204.6,115 204.6,120.4 L204.6,198.8 C204.6,204.2 200.2,208.6 194.8,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,158.4 C220.1,158.4 215.7,154 215.7,148.6 L215.7,120.4 C215.7,115 220.1,110.6 225.5,110.6 C230.9,110.6 235.3,115 235.3,120.4 L235.3,148.6 C235.3,154 230.9,158.4 225.5,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,208.6 C250.8,208.6 246.4,204.2 246.4,198.8 L246.4,120.4 C246.4,115 250.8,110.6 256.2,110.6 C261.6,110.6 266,115 266,120.4 L266,198.8 C266,204.2 261.6,208.6 256.2,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,158.4 C281.5,158.4 277.1,154 277.1,148.6 L277.1,120.4 C277.1,115 281.5,110.6 286.9,110.6 C292.3,110.6 296.7,115 296.7,120.4 L296.7,148.6 C296.7,154 292.3,158.4 286.9,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,207.4 C35.7,207.4 31.3,203 31.3,197.6 L31.3,178.8 C31.3,173.4 35.7,169 41.1,169 C46.5,169 50.9,173.4 50.9,178.8 L50.9,197.6 C50.9,203 46.5,207.4 41.1,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,207.4 C97.2,207.4 92.8,203 92.8,197.6 L92.8,178.8 C92.8,173.4 97.2,169 102.6,169 C108,169 112.4,173.4 112.4,178.8 L112.4,197.6 C112.4,203 108,207.4 102.6,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,207.4 C158.6,207.4 154.2,203 154.2,197.6 L154.2,178.8 C154.2,173.4 158.6,169 164,169 C169.4,169 173.8,173.4 173.8,178.8 L173.8,197.6 C173.8,203 169.4,207.4 164,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,207.4 C220.1,207.4 215.7,203 215.7,197.6 L215.7,178.8 C215.7,173.4 220.1,169 225.5,169 C230.9,169 235.3,173.4 235.3,178.8 L235.3,197.6 C235.3,203 230.9,207.4 225.5,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,207.4 C281.5,207.4 277.1,203 277.1,197.6 L277.1,178.8 C277.1,173.4 281.5,169 286.9,169 C292.3,169 296.7,173.4 296.7,178.8 L296.7,197.6 C296.7,203 292.3,207.4 286.9,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(128.000000, 466.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.9,98.3 C322.3,98.3 326.7,93.9 326.7,88.5 L326.7,10.1 C326.7,4.7 322.3,0.3 316.9,0.3 C311.5,0.3 307.1,4.7 307.1,10.1 L307.1,88.5 C307.1,93.9 311.5,98.3 316.9,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,98.3 C291.6,98.3 296,93.9 296,88.5 L296,10.1 C296,4.7 291.6,0.3 286.2,0.3 C280.8,0.3 276.4,4.7 276.4,10.1 L276.4,88.5 C276.3,93.9 280.7,98.3 286.2,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,98.3 C260.8,98.3 265.2,93.9 265.2,88.5 L265.2,10.1 C265.2,4.7 260.8,0.3 255.4,0.3 C250,0.3 245.6,4.7 245.6,10.1 L245.6,88.5 C245.6,93.9 250,98.3 255.4,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,98.3 C230.1,98.3 234.5,93.9 234.5,88.5 L234.5,10.1 C234.5,4.7 230.1,0.3 224.7,0.3 C219.3,0.3 214.9,4.7 214.9,10.1 L214.9,88.5 C214.9,93.9 219.3,98.3 224.7,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,98.3 C199.4,98.3 203.8,93.9 203.8,88.5 L203.8,10.1 C203.8,4.7 199.4,0.3 194,0.3 C188.6,0.3 184.2,4.7 184.2,10.1 L184.2,88.5 C184.2,93.9 188.6,98.3 194,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,98.3 C168.6,98.3 173,93.9 173,88.5 L173,10.1 C173,4.7 168.6,0.3 163.2,0.3 C157.8,0.3 153.4,4.7 153.4,10.1 L153.4,88.5 C153.4,93.9 157.8,98.3 163.2,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,98.3 C137.9,98.3 142.3,93.9 142.3,88.5 L142.3,10.1 C142.3,4.7 137.9,0.3 132.5,0.3 C127.1,0.3 122.7,4.7 122.7,10.1 L122.7,88.5 C122.7,93.9 127.1,98.3 132.5,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,98.3 C107.2,98.3 111.6,93.9 111.6,88.5 L111.6,10.1 C111.6,4.7 107.2,0.3 101.8,0.3 C96.4,0.3 92,4.7 92,10.1 L92,88.5 C92,93.9 96.4,98.3 101.8,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,98.3 C76.5,98.3 80.9,93.9 80.9,88.5 L80.9,10.1 C80.9,4.7 76.5,0.3 71.1,0.3 C65.7,0.3 61.3,4.7 61.3,10.1 L61.3,88.5 C61.3,93.9 65.7,98.3 71.1,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,98.3 C45.7,98.3 50.1,93.9 50.1,88.5 L50.1,10.1 C50.1,4.7 45.7,0.3 40.3,0.3 C34.9,0.3 30.5,4.7 30.5,10.1 L30.5,88.5 C30.5,93.9 34.9,98.3 40.3,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9,208.6 C322.3,208.6 326.7,204.2 326.7,198.8 L326.7,120.4 C326.7,115 322.3,110.6 316.9,110.6 C311.5,110.6 307.1,115 307.1,120.4 L307.1,198.8 C307.1,204.2 311.5,208.6 316.9,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,98.3 C15.3,98.3 19.7,93.9 19.7,88.5 L19.7,10.1 C19.7,4.7 15.3,0.3 9.9,0.3 C4.5,0.3 0.1,4.7 0.1,10.1 L0.1,88.5 C0.1,93.9 4.5,98.3 9.9,98.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,208.6 C15.3,208.6 19.7,204.2 19.7,198.8 L19.7,120.4 C19.7,115 15.3,110.6 9.9,110.6 C4.5,110.6 0.1,115 0.1,120.4 L0.1,198.8 C0.1,204.2 4.5,208.6 9.9,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,158.4 C291.6,158.4 296,154 296,148.6 L296,120.4 C296,115 291.6,110.6 286.2,110.6 C280.8,110.6 276.4,115 276.4,120.4 L276.4,148.6 C276.3,154 280.7,158.4 286.2,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,208.6 C260.8,208.6 265.2,204.2 265.2,198.8 L265.2,120.4 C265.2,115 260.8,110.6 255.4,110.6 C250,110.6 245.6,115 245.6,120.4 L245.6,198.8 C245.6,204.2 250,208.6 255.4,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,158.4 C230.1,158.4 234.5,154 234.5,148.6 L234.5,120.4 C234.5,115 230.1,110.6 224.7,110.6 C219.3,110.6 214.9,115 214.9,120.4 L214.9,148.6 C214.9,154 219.3,158.4 224.7,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,208.6 C199.4,208.6 203.8,204.2 203.8,198.8 L203.8,120.4 C203.8,115 199.4,110.6 194,110.6 C188.6,110.6 184.2,115 184.2,120.4 L184.2,198.8 C184.2,204.2 188.6,208.6 194,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,158.4 C168.6,158.4 173,154 173,148.6 L173,120.4 C173,115 168.6,110.6 163.2,110.6 C157.8,110.6 153.4,115 153.4,120.4 L153.4,148.6 C153.4,154 157.8,158.4 163.2,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,208.6 C137.9,208.6 142.3,204.2 142.3,198.8 L142.3,120.4 C142.3,115 137.9,110.6 132.5,110.6 C127.1,110.6 122.7,115 122.7,120.4 L122.7,198.8 C122.7,204.2 127.1,208.6 132.5,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,158.4 C107.2,158.4 111.6,154 111.6,148.6 L111.6,120.4 C111.6,115 107.2,110.6 101.8,110.6 C96.4,110.6 92,115 92,120.4 L92,148.6 C92,154 96.4,158.4 101.8,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,208.6 C76.5,208.6 80.9,204.2 80.9,198.8 L80.9,120.4 C80.9,115 76.5,110.6 71.1,110.6 C65.7,110.6 61.3,115 61.3,120.4 L61.3,198.8 C61.3,204.2 65.7,208.6 71.1,208.6 Z",
    id: "Shape",
    fill: "url(#linearGradient-103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,158.4 C45.7,158.4 50.1,154 50.1,148.6 L50.1,120.4 C50.1,115 45.7,110.6 40.3,110.6 C34.9,110.6 30.5,115 30.5,120.4 L30.5,148.6 C30.5,154 34.9,158.4 40.3,158.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,207.4 C291.6,207.4 296,203 296,197.6 L296,178.8 C296,173.4 291.6,169 286.2,169 C280.8,169 276.4,173.4 276.4,178.8 L276.4,197.6 C276.3,203 280.7,207.4 286.2,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,207.4 C230.1,207.4 234.5,203 234.5,197.6 L234.5,178.8 C234.5,173.4 230.1,169 224.7,169 C219.3,169 214.9,173.4 214.9,178.8 L214.9,197.6 C214.9,203 219.3,207.4 224.7,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,207.4 C168.6,207.4 173,203 173,197.6 L173,178.8 C173,173.4 168.6,169 163.2,169 C157.8,169 153.4,173.4 153.4,178.8 L153.4,197.6 C153.4,203 157.8,207.4 163.2,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,207.4 C107.2,207.4 111.6,203 111.6,197.6 L111.6,178.8 C111.6,173.4 107.2,169 101.8,169 C96.4,169 92,173.4 92,178.8 L92,197.6 C92,203 96.4,207.4 101.8,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,207.4 C45.7,207.4 50.1,203 50.1,197.6 L50.1,178.8 C50.1,173.4 45.7,169 40.3,169 C34.9,169 30.5,173.4 30.5,178.8 L30.5,197.6 C30.5,203 34.9,207.4 40.3,207.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-109)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(808.000000, 233.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,98.2 C5,98.2 0.6,93.8 0.6,88.4 L0.6,10 C0.6,4.6 5,0.2 10.4,0.2 C15.8,0.2 20.2,4.6 20.2,10 L20.2,88.4 C20.2,93.8 15.8,98.2 10.4,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,98.2 C35.7,98.2 31.3,93.8 31.3,88.4 L31.3,10 C31.3,4.6 35.7,0.2 41.1,0.2 C46.5,0.2 50.9,4.6 50.9,10 L50.9,88.4 C50.9,93.8 46.5,98.2 41.1,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,98.2 C66.4,98.2 62,93.8 62,88.4 L62,10 C62,4.6 66.4,0.2 71.8,0.2 C77.2,0.2 81.6,4.6 81.6,10 L81.6,88.4 C81.7,93.8 77.3,98.2 71.8,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,98.2 C97.2,98.2 92.8,93.8 92.8,88.4 L92.8,10 C92.8,4.6 97.2,0.2 102.6,0.2 C108,0.2 112.4,4.6 112.4,10 L112.4,88.4 C112.4,93.8 108,98.2 102.6,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,98.2 C127.9,98.2 123.5,93.8 123.5,88.4 L123.5,10 C123.5,4.6 127.9,0.2 133.3,0.2 C138.7,0.2 143.1,4.6 143.1,10 L143.1,88.4 C143.1,93.8 138.7,98.2 133.3,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,98.2 C158.6,98.2 154.2,93.8 154.2,88.4 L154.2,10 C154.2,4.6 158.6,0.2 164,0.2 C169.4,0.2 173.8,4.6 173.8,10 L173.8,88.4 C173.8,93.8 169.4,98.2 164,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,98.2 C189.4,98.2 185,93.8 185,88.4 L185,10 C185,4.6 189.4,0.2 194.8,0.2 C200.2,0.2 204.6,4.6 204.6,10 L204.6,88.4 C204.6,93.8 200.2,98.2 194.8,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,98.2 C220.1,98.2 215.7,93.8 215.7,88.4 L215.7,10 C215.7,4.6 220.1,0.2 225.5,0.2 C230.9,0.2 235.3,4.6 235.3,10 L235.3,88.4 C235.3,93.8 230.9,98.2 225.5,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,98.2 C250.8,98.2 246.4,93.8 246.4,88.4 L246.4,10 C246.4,4.6 250.8,0.2 256.2,0.2 C261.6,0.2 266,4.6 266,10 L266,88.4 C266,93.8 261.6,98.2 256.2,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,98.2 C281.5,98.2 277.1,93.8 277.1,88.4 L277.1,10 C277.1,4.6 281.5,0.2 286.9,0.2 C292.3,0.2 296.7,4.6 296.7,10 L296.7,88.4 C296.7,93.8 292.3,98.2 286.9,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,208.5 C5,208.5 0.6,204.1 0.6,198.7 L0.6,120.3 C0.6,114.9 5,110.5 10.4,110.5 C15.8,110.5 20.2,114.9 20.2,120.3 L20.2,198.7 C20.2,204.1 15.8,208.5 10.4,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,98.2 C312,98.2 307.6,93.8 307.6,88.4 L307.6,10 C307.6,4.6 312,0.2 317.4,0.2 C322.8,0.2 327.2,4.6 327.2,10 L327.2,88.4 C327.2,93.8 322.8,98.2 317.4,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,208.5 C312,208.5 307.6,204.1 307.6,198.7 L307.6,120.3 C307.6,114.9 312,110.5 317.4,110.5 C322.8,110.5 327.2,114.9 327.2,120.3 L327.2,198.7 C327.2,204.1 322.8,208.5 317.4,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-122)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,158.2 C35.7,158.2 31.3,153.8 31.3,148.4 L31.3,120.2 C31.3,114.8 35.7,110.4 41.1,110.4 C46.5,110.4 50.9,114.8 50.9,120.2 L50.9,148.4 C50.9,153.8 46.5,158.2 41.1,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,208.5 C66.4,208.5 62,204.1 62,198.7 L62,120.3 C62,114.9 66.4,110.5 71.8,110.5 C77.2,110.5 81.6,114.9 81.6,120.3 L81.6,198.7 C81.7,204.1 77.3,208.5 71.8,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,158.2 C97.2,158.2 92.8,153.8 92.8,148.4 L92.8,120.2 C92.8,114.8 97.2,110.4 102.6,110.4 C108,110.4 112.4,114.8 112.4,120.2 L112.4,148.4 C112.4,153.8 108,158.2 102.6,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,208.5 C127.9,208.5 123.5,204.1 123.5,198.7 L123.5,120.3 C123.5,114.9 127.9,110.5 133.3,110.5 C138.7,110.5 143.1,114.9 143.1,120.3 L143.1,198.7 C143.1,204.1 138.7,208.5 133.3,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,158.2 C158.6,158.2 154.2,153.8 154.2,148.4 L154.2,120.2 C154.2,114.8 158.6,110.4 164,110.4 C169.4,110.4 173.8,114.8 173.8,120.2 L173.8,148.4 C173.8,153.8 169.4,158.2 164,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,208.5 C189.4,208.5 185,204.1 185,198.7 L185,120.3 C185,114.9 189.4,110.5 194.8,110.5 C200.2,110.5 204.6,114.9 204.6,120.3 L204.6,198.7 C204.6,204.1 200.2,208.5 194.8,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,158.2 C220.1,158.2 215.7,153.8 215.7,148.4 L215.7,120.2 C215.7,114.8 220.1,110.4 225.5,110.4 C230.9,110.4 235.3,114.8 235.3,120.2 L235.3,148.4 C235.3,153.8 230.9,158.2 225.5,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,208.5 C250.8,208.5 246.4,204.1 246.4,198.7 L246.4,120.3 C246.4,114.9 250.8,110.5 256.2,110.5 C261.6,110.5 266,114.9 266,120.3 L266,198.7 C266,204.1 261.6,208.5 256.2,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,158.2 C281.5,158.2 277.1,153.8 277.1,148.4 L277.1,120.2 C277.1,114.8 281.5,110.4 286.9,110.4 C292.3,110.4 296.7,114.8 296.7,120.2 L296.7,148.4 C296.7,153.8 292.3,158.2 286.9,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,207.2 C35.7,207.2 31.3,202.8 31.3,197.4 L31.3,178.6 C31.3,173.2 35.7,168.8 41.1,168.8 C46.5,168.8 50.9,173.2 50.9,178.6 L50.9,197.4 C50.9,202.9 46.5,207.2 41.1,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,207.2 C97.2,207.2 92.8,202.8 92.8,197.4 L92.8,178.6 C92.8,173.2 97.2,168.8 102.6,168.8 C108,168.8 112.4,173.2 112.4,178.6 L112.4,197.4 C112.4,202.9 108,207.2 102.6,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,207.2 C158.6,207.2 154.2,202.8 154.2,197.4 L154.2,178.6 C154.2,173.2 158.6,168.8 164,168.8 C169.4,168.8 173.8,173.2 173.8,178.6 L173.8,197.4 C173.8,202.9 169.4,207.2 164,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,207.2 C220.1,207.2 215.7,202.8 215.7,197.4 L215.7,178.6 C215.7,173.2 220.1,168.8 225.5,168.8 C230.9,168.8 235.3,173.2 235.3,178.6 L235.3,197.4 C235.3,202.9 230.9,207.2 225.5,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,207.2 C281.5,207.2 277.1,202.8 277.1,197.4 L277.1,178.6 C277.1,173.2 281.5,168.8 286.9,168.8 C292.3,168.8 296.7,173.2 296.7,178.6 L296.7,197.4 C296.7,202.9 292.3,207.2 286.9,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-136)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(467.000000, 233.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7,98.2 C5.3,98.2 0.9,93.8 0.9,88.4 L0.9,10 C0.9,4.6 5.3,0.2 10.7,0.2 C16.1,0.2 20.5,4.6 20.5,10 L20.5,88.4 C20.5,93.8 16.2,98.2 10.7,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,98.2 C36.1,98.2 31.7,93.8 31.7,88.4 L31.7,10 C31.7,4.6 36.1,0.2 41.5,0.2 C46.9,0.2 51.3,4.6 51.3,10 L51.3,88.4 C51.3,93.8 46.9,98.2 41.5,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,98.2 C66.8,98.2 62.4,93.8 62.4,88.4 L62.4,10 C62.4,4.6 66.8,0.2 72.2,0.2 C77.6,0.2 82,4.6 82,10 L82,88.4 C82,93.8 77.6,98.2 72.2,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,98.2 C97.5,98.2 93.1,93.8 93.1,88.4 L93.1,10 C93.1,4.6 97.5,0.2 102.9,0.2 C108.3,0.2 112.7,4.6 112.7,10 L112.7,88.4 C112.7,93.8 108.3,98.2 102.9,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,98.2 C128.2,98.2 123.8,93.8 123.8,88.4 L123.8,10 C123.8,4.6 128.2,0.2 133.6,0.2 C139,0.2 143.4,4.6 143.4,10 L143.4,88.4 C143.5,93.8 139.1,98.2 133.6,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,98.2 C159,98.2 154.6,93.8 154.6,88.4 L154.6,10 C154.6,4.6 159,0.2 164.4,0.2 C169.8,0.2 174.2,4.6 174.2,10 L174.2,88.4 C174.2,93.8 169.8,98.2 164.4,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,98.2 C189.7,98.2 185.3,93.8 185.3,88.4 L185.3,10 C185.3,4.6 189.7,0.2 195.1,0.2 C200.5,0.2 204.9,4.6 204.9,10 L204.9,88.4 C204.9,93.8 200.5,98.2 195.1,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,98.2 C220.4,98.2 216,93.8 216,88.4 L216,10 C216,4.6 220.4,0.2 225.8,0.2 C231.2,0.2 235.6,4.6 235.6,10 L235.6,88.4 C235.6,93.8 231.2,98.2 225.8,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,98.2 C251.2,98.2 246.8,93.8 246.8,88.4 L246.8,10 C246.8,4.6 251.2,0.2 256.6,0.2 C262,0.2 266.4,4.6 266.4,10 L266.4,88.4 C266.4,93.8 262,98.2 256.6,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,98.2 C281.9,98.2 277.5,93.8 277.5,88.4 L277.5,10 C277.5,4.6 281.9,0.2 287.3,0.2 C292.7,0.2 297.1,4.6 297.1,10 L297.1,88.4 C297.1,93.8 292.7,98.2 287.3,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,208.5 C5.3,208.5 0.9,204.1 0.9,198.7 L0.9,120.3 C0.9,114.9 5.3,110.5 10.7,110.5 C16.1,110.5 20.5,114.9 20.5,120.3 L20.5,198.7 C20.5,204.1 16.2,208.5 10.7,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7,98.2 C312.3,98.2 307.9,93.8 307.9,88.4 L307.9,10 C307.9,4.6 312.3,0.2 317.7,0.2 C323.1,0.2 327.5,4.6 327.5,10 L327.5,88.4 C327.5,93.8 323.1,98.2 317.7,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7,208.5 C312.3,208.5 307.9,204.1 307.9,198.7 L307.9,120.3 C307.9,114.9 312.3,110.5 317.7,110.5 C323.1,110.5 327.5,114.9 327.5,120.3 L327.5,198.7 C327.5,204.1 323.1,208.5 317.7,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,158.2 C36.1,158.2 31.7,153.8 31.7,148.4 L31.7,120.2 C31.7,114.8 36.1,110.4 41.5,110.4 C46.9,110.4 51.3,114.8 51.3,120.2 L51.3,148.4 C51.3,153.8 46.9,158.2 41.5,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,208.5 C66.8,208.5 62.4,204.1 62.4,198.7 L62.4,120.3 C62.4,114.9 66.8,110.5 72.2,110.5 C77.6,110.5 82,114.9 82,120.3 L82,198.7 C82,204.1 77.6,208.5 72.2,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,158.2 C97.5,158.2 93.1,153.8 93.1,148.4 L93.1,120.2 C93.1,114.8 97.5,110.4 102.9,110.4 C108.3,110.4 112.7,114.8 112.7,120.2 L112.7,148.4 C112.7,153.8 108.3,158.2 102.9,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,208.5 C128.2,208.5 123.8,204.1 123.8,198.7 L123.8,120.3 C123.8,114.9 128.2,110.5 133.6,110.5 C139,110.5 143.4,114.9 143.4,120.3 L143.4,198.7 C143.5,204.1 139.1,208.5 133.6,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,158.2 C159,158.2 154.6,153.8 154.6,148.4 L154.6,120.2 C154.6,114.8 159,110.4 164.4,110.4 C169.8,110.4 174.2,114.8 174.2,120.2 L174.2,148.4 C174.2,153.8 169.8,158.2 164.4,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,208.5 C189.7,208.5 185.3,204.1 185.3,198.7 L185.3,120.3 C185.3,114.9 189.7,110.5 195.1,110.5 C200.5,110.5 204.9,114.9 204.9,120.3 L204.9,198.7 C204.9,204.1 200.5,208.5 195.1,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,158.2 C220.4,158.2 216,153.8 216,148.4 L216,120.2 C216,114.8 220.4,110.4 225.8,110.4 C231.2,110.4 235.6,114.8 235.6,120.2 L235.6,148.4 C235.6,153.8 231.2,158.2 225.8,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,208.5 C251.2,208.5 246.8,204.1 246.8,198.7 L246.8,120.3 C246.8,114.9 251.2,110.5 256.6,110.5 C262,110.5 266.4,114.9 266.4,120.3 L266.4,198.7 C266.4,204.1 262,208.5 256.6,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-157)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,158.2 C281.9,158.2 277.5,153.8 277.5,148.4 L277.5,120.2 C277.5,114.8 281.9,110.4 287.3,110.4 C292.7,110.4 297.1,114.8 297.1,120.2 L297.1,148.4 C297.1,153.8 292.7,158.2 287.3,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,207.2 C36.1,207.2 31.7,202.8 31.7,197.4 L31.7,178.6 C31.7,173.2 36.1,168.8 41.5,168.8 C46.9,168.8 51.3,173.2 51.3,178.6 L51.3,197.4 C51.3,202.9 46.9,207.2 41.5,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,207.2 C97.5,207.2 93.1,202.8 93.1,197.4 L93.1,178.6 C93.1,173.2 97.5,168.8 102.9,168.8 C108.3,168.8 112.7,173.2 112.7,178.6 L112.7,197.4 C112.7,202.9 108.3,207.2 102.9,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,207.2 C159,207.2 154.6,202.8 154.6,197.4 L154.6,178.6 C154.6,173.2 159,168.8 164.4,168.8 C169.8,168.8 174.2,173.2 174.2,178.6 L174.2,197.4 C174.2,202.9 169.8,207.2 164.4,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,207.2 C220.4,207.2 216,202.8 216,197.4 L216,178.6 C216,173.2 220.4,168.8 225.8,168.8 C231.2,168.8 235.6,173.2 235.6,178.6 L235.6,197.4 C235.6,202.9 231.2,207.2 225.8,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,207.2 C281.9,207.2 277.5,202.8 277.5,197.4 L277.5,178.6 C277.5,173.2 281.9,168.8 287.3,168.8 C292.7,168.8 297.1,173.2 297.1,178.6 L297.1,197.4 C297.1,202.9 292.7,207.2 287.3,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-163)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(128.000000, 233.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.9,98.2 C322.3,98.2 326.7,93.8 326.7,88.4 L326.7,10 C326.7,4.6 322.3,0.2 316.9,0.2 C311.5,0.2 307.1,4.6 307.1,10 L307.1,88.4 C307.1,93.8 311.5,98.2 316.9,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,98.2 C291.6,98.2 296,93.8 296,88.4 L296,10 C296,4.6 291.6,0.2 286.2,0.2 C280.8,0.2 276.4,4.6 276.4,10 L276.4,88.4 C276.3,93.8 280.7,98.2 286.2,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,98.2 C260.8,98.2 265.2,93.8 265.2,88.4 L265.2,10 C265.2,4.6 260.8,0.2 255.4,0.2 C250,0.2 245.6,4.6 245.6,10 L245.6,88.4 C245.6,93.8 250,98.2 255.4,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,98.2 C230.1,98.2 234.5,93.8 234.5,88.4 L234.5,10 C234.5,4.6 230.1,0.2 224.7,0.2 C219.3,0.2 214.9,4.6 214.9,10 L214.9,88.4 C214.9,93.8 219.3,98.2 224.7,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,98.2 C199.4,98.2 203.8,93.8 203.8,88.4 L203.8,10 C203.8,4.6 199.4,0.2 194,0.2 C188.6,0.2 184.2,4.6 184.2,10 L184.2,88.4 C184.2,93.8 188.6,98.2 194,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,98.2 C168.6,98.2 173,93.8 173,88.4 L173,10 C173,4.6 168.6,0.2 163.2,0.2 C157.8,0.2 153.4,4.6 153.4,10 L153.4,88.4 C153.4,93.8 157.8,98.2 163.2,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,98.2 C137.9,98.2 142.3,93.8 142.3,88.4 L142.3,10 C142.3,4.6 137.9,0.2 132.5,0.2 C127.1,0.2 122.7,4.6 122.7,10 L122.7,88.4 C122.7,93.8 127.1,98.2 132.5,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,98.2 C107.2,98.2 111.6,93.8 111.6,88.4 L111.6,10 C111.6,4.6 107.2,0.2 101.8,0.2 C96.4,0.2 92,4.6 92,10 L92,88.4 C92,93.8 96.4,98.2 101.8,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,98.2 C76.5,98.2 80.9,93.8 80.9,88.4 L80.9,10 C80.9,4.6 76.5,0.2 71.1,0.2 C65.7,0.2 61.3,4.6 61.3,10 L61.3,88.4 C61.3,93.8 65.7,98.2 71.1,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,98.2 C45.7,98.2 50.1,93.8 50.1,88.4 L50.1,10 C50.1,4.6 45.7,0.2 40.3,0.2 C34.9,0.2 30.5,4.6 30.5,10 L30.5,88.4 C30.5,93.8 34.9,98.2 40.3,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9,208.5 C322.3,208.5 326.7,204.1 326.7,198.7 L326.7,120.3 C326.7,114.9 322.3,110.5 316.9,110.5 C311.5,110.5 307.1,114.9 307.1,120.3 L307.1,198.7 C307.1,204.1 311.5,208.5 316.9,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,98.2 C15.3,98.2 19.7,93.8 19.7,88.4 L19.7,10 C19.7,4.6 15.3,0.2 9.9,0.2 C4.5,0.2 0.1,4.6 0.1,10 L0.1,88.4 C0.1,93.8 4.5,98.2 9.9,98.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,208.5 C15.3,208.5 19.7,204.1 19.7,198.7 L19.7,120.3 C19.7,114.9 15.3,110.5 9.9,110.5 C4.5,110.5 0.1,114.9 0.1,120.3 L0.1,198.7 C0.1,204.1 4.5,208.5 9.9,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,158.2 C291.6,158.2 296,153.8 296,148.4 L296,120.2 C296,114.8 291.6,110.4 286.2,110.4 C280.8,110.4 276.4,114.8 276.4,120.2 L276.4,148.4 C276.3,153.8 280.7,158.2 286.2,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,208.5 C260.8,208.5 265.2,204.1 265.2,198.7 L265.2,120.3 C265.2,114.9 260.8,110.5 255.4,110.5 C250,110.5 245.6,114.9 245.6,120.3 L245.6,198.7 C245.6,204.1 250,208.5 255.4,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,158.2 C230.1,158.2 234.5,153.8 234.5,148.4 L234.5,120.2 C234.5,114.8 230.1,110.4 224.7,110.4 C219.3,110.4 214.9,114.8 214.9,120.2 L214.9,148.4 C214.9,153.8 219.3,158.2 224.7,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,208.5 C199.4,208.5 203.8,204.1 203.8,198.7 L203.8,120.3 C203.8,114.9 199.4,110.5 194,110.5 C188.6,110.5 184.2,114.9 184.2,120.3 L184.2,198.7 C184.2,204.1 188.6,208.5 194,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,158.2 C168.6,158.2 173,153.8 173,148.4 L173,120.2 C173,114.8 168.6,110.4 163.2,110.4 C157.8,110.4 153.4,114.8 153.4,120.2 L153.4,148.4 C153.4,153.8 157.8,158.2 163.2,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,208.5 C137.9,208.5 142.3,204.1 142.3,198.7 L142.3,120.3 C142.3,114.9 137.9,110.5 132.5,110.5 C127.1,110.5 122.7,114.9 122.7,120.3 L122.7,198.7 C122.7,204.1 127.1,208.5 132.5,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,158.2 C107.2,158.2 111.6,153.8 111.6,148.4 L111.6,120.2 C111.6,114.8 107.2,110.4 101.8,110.4 C96.4,110.4 92,114.8 92,120.2 L92,148.4 C92,153.8 96.4,158.2 101.8,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,208.5 C76.5,208.5 80.9,204.1 80.9,198.7 L80.9,120.3 C80.9,114.9 76.5,110.5 71.1,110.5 C65.7,110.5 61.3,114.9 61.3,120.3 L61.3,198.7 C61.3,204.1 65.7,208.5 71.1,208.5 Z",
    id: "Shape",
    fill: "url(#linearGradient-184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,158.2 C45.7,158.2 50.1,153.8 50.1,148.4 L50.1,120.2 C50.1,114.8 45.7,110.4 40.3,110.4 C34.9,110.4 30.5,114.8 30.5,120.2 L30.5,148.4 C30.5,153.8 34.9,158.2 40.3,158.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,207.2 C291.6,207.2 296,202.8 296,197.4 L296,178.6 C296,173.2 291.6,168.8 286.2,168.8 C280.8,168.8 276.4,173.2 276.4,178.6 L276.4,197.4 C276.3,202.9 280.7,207.2 286.2,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,207.2 C230.1,207.2 234.5,202.8 234.5,197.4 L234.5,178.6 C234.5,173.2 230.1,168.8 224.7,168.8 C219.3,168.8 214.9,173.2 214.9,178.6 L214.9,197.4 C214.9,202.9 219.3,207.2 224.7,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,207.2 C168.6,207.2 173,202.8 173,197.4 L173,178.6 C173,173.2 168.6,168.8 163.2,168.8 C157.8,168.8 153.4,173.2 153.4,178.6 L153.4,197.4 C153.4,202.9 157.8,207.2 163.2,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,207.2 C107.2,207.2 111.6,202.8 111.6,197.4 L111.6,178.6 C111.6,173.2 107.2,168.8 101.8,168.8 C96.4,168.8 92,173.2 92,178.6 L92,197.4 C92,202.9 96.4,207.2 101.8,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,207.2 C45.7,207.2 50.1,202.8 50.1,197.4 L50.1,178.6 C50.1,173.2 45.7,168.8 40.3,168.8 C34.9,168.8 30.5,173.2 30.5,178.6 L30.5,197.4 C30.5,202.9 34.9,207.2 40.3,207.2 Z",
    id: "Shape",
    fill: "url(#linearGradient-190)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(808.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,98 C5,98 0.6,93.6 0.6,88.2 L0.6,9.8 C0.6,4.4 5,0 10.4,0 C15.8,0 20.2,4.4 20.2,9.8 L20.2,88.2 C20.2,93.6 15.8,98 10.4,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-191)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,98 C35.7,98 31.3,93.6 31.3,88.2 L31.3,9.8 C31.3,4.4 35.7,0 41.1,0 C46.5,0 50.9,4.4 50.9,9.8 L50.9,88.2 C50.9,93.6 46.5,98 41.1,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,98 C66.4,98 62,93.6 62,88.2 L62,9.8 C62,4.4 66.4,0 71.8,0 C77.2,0 81.6,4.4 81.6,9.8 L81.6,88.2 C81.7,93.6 77.3,98 71.8,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,98 C97.2,98 92.8,93.6 92.8,88.2 L92.8,9.8 C92.8,4.4 97.2,0 102.6,0 C108,0 112.4,4.4 112.4,9.8 L112.4,88.2 C112.4,93.6 108,98 102.6,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,98 C127.9,98 123.5,93.6 123.5,88.2 L123.5,9.8 C123.5,4.4 127.9,0 133.3,0 C138.7,0 143.1,4.4 143.1,9.8 L143.1,88.2 C143.1,93.6 138.7,98 133.3,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-195)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,98 C158.6,98 154.2,93.6 154.2,88.2 L154.2,9.8 C154.2,4.4 158.6,0 164,0 C169.4,0 173.8,4.4 173.8,9.8 L173.8,88.2 C173.8,93.6 169.4,98 164,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,98 C189.4,98 185,93.6 185,88.2 L185,9.8 C185,4.4 189.4,0 194.8,0 C200.2,0 204.6,4.4 204.6,9.8 L204.6,88.2 C204.6,93.6 200.2,98 194.8,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,98 C220.1,98 215.7,93.6 215.7,88.2 L215.7,9.8 C215.7,4.4 220.1,0 225.5,0 C230.9,0 235.3,4.4 235.3,9.8 L235.3,88.2 C235.3,93.6 230.9,98 225.5,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-198)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,98 C250.8,98 246.4,93.6 246.4,88.2 L246.4,9.8 C246.4,4.4 250.8,0 256.2,0 C261.6,0 266,4.4 266,9.8 L266,88.2 C266,93.6 261.6,98 256.2,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,98 C281.5,98 277.1,93.6 277.1,88.2 L277.1,9.8 C277.1,4.4 281.5,0 286.9,0 C292.3,0 296.7,4.4 296.7,9.8 L296.7,88.2 C296.7,93.6 292.3,98 286.9,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,208.3 C5,208.3 0.6,203.9 0.6,198.5 L0.6,120.1 C0.6,114.7 5,110.3 10.4,110.3 C15.8,110.3 20.2,114.7 20.2,120.1 L20.2,198.5 C20.2,203.9 15.8,208.3 10.4,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,98 C312,98 307.6,93.6 307.6,88.2 L307.6,9.8 C307.6,4.4 312,0 317.4,0 C322.8,0 327.2,4.4 327.2,9.8 L327.2,88.2 C327.2,93.6 322.8,98 317.4,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-202)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,208.3 C312,208.3 307.6,203.9 307.6,198.5 L307.6,120.1 C307.6,114.7 312,110.3 317.4,110.3 C322.8,110.3 327.2,114.7 327.2,120.1 L327.2,198.5 C327.2,203.9 322.8,208.3 317.4,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,158.1 C35.7,158.1 31.3,153.7 31.3,148.3 L31.3,120.1 C31.3,114.7 35.7,110.3 41.1,110.3 C46.5,110.3 50.9,114.7 50.9,120.1 L50.9,148.3 C50.9,153.7 46.5,158.1 41.1,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,208.3 C66.4,208.3 62,203.9 62,198.5 L62,120.1 C62,114.7 66.4,110.3 71.8,110.3 C77.2,110.3 81.6,114.7 81.6,120.1 L81.6,198.5 C81.7,203.9 77.3,208.3 71.8,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,158.1 C97.2,158.1 92.8,153.7 92.8,148.3 L92.8,120.1 C92.8,114.7 97.2,110.3 102.6,110.3 C108,110.3 112.4,114.7 112.4,120.1 L112.4,148.3 C112.4,153.7 108,158.1 102.6,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,208.3 C127.9,208.3 123.5,203.9 123.5,198.5 L123.5,120.1 C123.5,114.7 127.9,110.3 133.3,110.3 C138.7,110.3 143.1,114.7 143.1,120.1 L143.1,198.5 C143.1,203.9 138.7,208.3 133.3,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,158.1 C158.6,158.1 154.2,153.7 154.2,148.3 L154.2,120.1 C154.2,114.7 158.6,110.3 164,110.3 C169.4,110.3 173.8,114.7 173.8,120.1 L173.8,148.3 C173.8,153.7 169.4,158.1 164,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,208.3 C189.4,208.3 185,203.9 185,198.5 L185,120.1 C185,114.7 189.4,110.3 194.8,110.3 C200.2,110.3 204.6,114.7 204.6,120.1 L204.6,198.5 C204.6,203.9 200.2,208.3 194.8,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,158.1 C220.1,158.1 215.7,153.7 215.7,148.3 L215.7,120.1 C215.7,114.7 220.1,110.3 225.5,110.3 C230.9,110.3 235.3,114.7 235.3,120.1 L235.3,148.3 C235.3,153.7 230.9,158.1 225.5,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,208.3 C250.8,208.3 246.4,203.9 246.4,198.5 L246.4,120.1 C246.4,114.7 250.8,110.3 256.2,110.3 C261.6,110.3 266,114.7 266,120.1 L266,198.5 C266,203.9 261.6,208.3 256.2,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-211)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,158.1 C281.5,158.1 277.1,153.7 277.1,148.3 L277.1,120.1 C277.1,114.7 281.5,110.3 286.9,110.3 C292.3,110.3 296.7,114.7 296.7,120.1 L296.7,148.3 C296.7,153.7 292.3,158.1 286.9,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-212)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,207.1 C35.7,207.1 31.3,202.7 31.3,197.3 L31.3,178.5 C31.3,173.1 35.7,168.7 41.1,168.7 C46.5,168.7 50.9,173.1 50.9,178.5 L50.9,197.3 C50.9,202.7 46.5,207.1 41.1,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-213)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,207.1 C97.2,207.1 92.8,202.7 92.8,197.3 L92.8,178.5 C92.8,173.1 97.2,168.7 102.6,168.7 C108,168.7 112.4,173.1 112.4,178.5 L112.4,197.3 C112.4,202.7 108,207.1 102.6,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,207.1 C158.6,207.1 154.2,202.7 154.2,197.3 L154.2,178.5 C154.2,173.1 158.6,168.7 164,168.7 C169.4,168.7 173.8,173.1 173.8,178.5 L173.8,197.3 C173.8,202.7 169.4,207.1 164,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,207.1 C220.1,207.1 215.7,202.7 215.7,197.3 L215.7,178.5 C215.7,173.1 220.1,168.7 225.5,168.7 C230.9,168.7 235.3,173.1 235.3,178.5 L235.3,197.3 C235.3,202.7 230.9,207.1 225.5,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,207.1 C281.5,207.1 277.1,202.7 277.1,197.3 L277.1,178.5 C277.1,173.1 281.5,168.7 286.9,168.7 C292.3,168.7 296.7,173.1 296.7,178.5 L296.7,197.3 C296.7,202.7 292.3,207.1 286.9,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-217)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(467.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7,98 C5.3,98 0.9,93.6 0.9,88.2 L0.9,9.8 C0.9,4.4 5.3,0 10.7,0 C16.1,0 20.5,4.4 20.5,9.8 L20.5,88.2 C20.5,93.6 16.2,98 10.7,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,98 C36.1,98 31.7,93.6 31.7,88.2 L31.7,9.8 C31.7,4.4 36.1,0 41.5,0 C46.9,0 51.3,4.4 51.3,9.8 L51.3,88.2 C51.3,93.6 46.9,98 41.5,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,98 C66.8,98 62.4,93.6 62.4,88.2 L62.4,9.8 C62.4,4.4 66.8,0 72.2,0 C77.6,0 82,4.4 82,9.8 L82,88.2 C82,93.6 77.6,98 72.2,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,98 C97.5,98 93.1,93.6 93.1,88.2 L93.1,9.8 C93.1,4.4 97.5,0 102.9,0 C108.3,0 112.7,4.4 112.7,9.8 L112.7,88.2 C112.7,93.6 108.3,98 102.9,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,98 C128.2,98 123.8,93.6 123.8,88.2 L123.8,9.8 C123.8,4.4 128.2,0 133.6,0 C139,0 143.4,4.4 143.4,9.8 L143.4,88.2 C143.5,93.6 139.1,98 133.6,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,98 C159,98 154.6,93.6 154.6,88.2 L154.6,9.8 C154.6,4.4 159,0 164.4,0 C169.8,0 174.2,4.4 174.2,9.8 L174.2,88.2 C174.2,93.6 169.8,98 164.4,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,98 C189.7,98 185.3,93.6 185.3,88.2 L185.3,9.8 C185.3,4.4 189.7,0 195.1,0 C200.5,0 204.9,4.4 204.9,9.8 L204.9,88.2 C204.9,93.6 200.5,98 195.1,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,98 C220.4,98 216,93.6 216,88.2 L216,9.8 C216,4.4 220.4,0 225.8,0 C231.2,0 235.6,4.4 235.6,9.8 L235.6,88.2 C235.6,93.6 231.2,98 225.8,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-225)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,98 C251.2,98 246.8,93.6 246.8,88.2 L246.8,9.8 C246.8,4.4 251.2,0 256.6,0 C262,0 266.4,4.4 266.4,9.8 L266.4,88.2 C266.4,93.6 262,98 256.6,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,98 C281.9,98 277.5,93.6 277.5,88.2 L277.5,9.8 C277.5,4.4 281.9,0 287.3,0 C292.7,0 297.1,4.4 297.1,9.8 L297.1,88.2 C297.1,93.6 292.7,98 287.3,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,208.3 C5.3,208.3 0.9,203.9 0.9,198.5 L0.9,120.1 C0.9,114.7 5.3,110.3 10.7,110.3 C16.1,110.3 20.5,114.7 20.5,120.1 L20.5,198.5 C20.5,203.9 16.2,208.3 10.7,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7,98 C312.3,98 307.9,93.6 307.9,88.2 L307.9,9.8 C307.9,4.4 312.3,0 317.7,0 C323.1,0 327.5,4.4 327.5,9.8 L327.5,88.2 C327.5,93.6 323.1,98 317.7,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7,208.3 C312.3,208.3 307.9,203.9 307.9,198.5 L307.9,120.1 C307.9,114.7 312.3,110.3 317.7,110.3 C323.1,110.3 327.5,114.7 327.5,120.1 L327.5,198.5 C327.5,203.9 323.1,208.3 317.7,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,158.1 C36.1,158.1 31.7,153.7 31.7,148.3 L31.7,120.1 C31.7,114.7 36.1,110.3 41.5,110.3 C46.9,110.3 51.3,114.7 51.3,120.1 L51.3,148.3 C51.3,153.7 46.9,158.1 41.5,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,208.3 C66.8,208.3 62.4,203.9 62.4,198.5 L62.4,120.1 C62.4,114.7 66.8,110.3 72.2,110.3 C77.6,110.3 82,114.7 82,120.1 L82,198.5 C82,203.9 77.6,208.3 72.2,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,158.1 C97.5,158.1 93.1,153.7 93.1,148.3 L93.1,120.1 C93.1,114.7 97.5,110.3 102.9,110.3 C108.3,110.3 112.7,114.7 112.7,120.1 L112.7,148.3 C112.7,153.7 108.3,158.1 102.9,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,208.3 C128.2,208.3 123.8,203.9 123.8,198.5 L123.8,120.1 C123.8,114.7 128.2,110.3 133.6,110.3 C139,110.3 143.4,114.7 143.4,120.1 L143.4,198.5 C143.5,203.9 139.1,208.3 133.6,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,158.1 C159,158.1 154.6,153.7 154.6,148.3 L154.6,120.1 C154.6,114.7 159,110.3 164.4,110.3 C169.8,110.3 174.2,114.7 174.2,120.1 L174.2,148.3 C174.2,153.7 169.8,158.1 164.4,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,208.3 C189.7,208.3 185.3,203.9 185.3,198.5 L185.3,120.1 C185.3,114.7 189.7,110.3 195.1,110.3 C200.5,110.3 204.9,114.7 204.9,120.1 L204.9,198.5 C204.9,203.9 200.5,208.3 195.1,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,158.1 C220.4,158.1 216,153.7 216,148.3 L216,120.1 C216,114.7 220.4,110.3 225.8,110.3 C231.2,110.3 235.6,114.7 235.6,120.1 L235.6,148.3 C235.6,153.7 231.2,158.1 225.8,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,208.3 C251.2,208.3 246.8,203.9 246.8,198.5 L246.8,120.1 C246.8,114.7 251.2,110.3 256.6,110.3 C262,110.3 266.4,114.7 266.4,120.1 L266.4,198.5 C266.4,203.9 262,208.3 256.6,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,158.1 C281.9,158.1 277.5,153.7 277.5,148.3 L277.5,120.1 C277.5,114.7 281.9,110.3 287.3,110.3 C292.7,110.3 297.1,114.7 297.1,120.1 L297.1,148.3 C297.1,153.7 292.7,158.1 287.3,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,207.1 C36.1,207.1 31.7,202.7 31.7,197.3 L31.7,178.5 C31.7,173.1 36.1,168.7 41.5,168.7 C46.9,168.7 51.3,173.1 51.3,178.5 L51.3,197.3 C51.3,202.7 46.9,207.1 41.5,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,207.1 C97.5,207.1 93.1,202.7 93.1,197.3 L93.1,178.5 C93.1,173.1 97.5,168.7 102.9,168.7 C108.3,168.7 112.7,173.1 112.7,178.5 L112.7,197.3 C112.7,202.7 108.3,207.1 102.9,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,207.1 C159,207.1 154.6,202.7 154.6,197.3 L154.6,178.5 C154.6,173.1 159,168.7 164.4,168.7 C169.8,168.7 174.2,173.1 174.2,178.5 L174.2,197.3 C174.2,202.7 169.8,207.1 164.4,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,207.1 C220.4,207.1 216,202.7 216,197.3 L216,178.5 C216,173.1 220.4,168.7 225.8,168.7 C231.2,168.7 235.6,173.1 235.6,178.5 L235.6,197.3 C235.6,202.7 231.2,207.1 225.8,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,207.1 C281.9,207.1 277.5,202.7 277.5,197.3 L277.5,178.5 C277.5,173.1 281.9,168.7 287.3,168.7 C292.7,168.7 297.1,173.1 297.1,178.5 L297.1,197.3 C297.1,202.7 292.7,207.1 287.3,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-244)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(128.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.9,98 C322.3,98 326.7,93.6 326.7,88.2 L326.7,9.8 C326.7,4.4 322.3,0 316.9,0 C311.5,0 307.1,4.4 307.1,9.8 L307.1,88.2 C307.1,93.6 311.5,98 316.9,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,98 C291.6,98 296,93.6 296,88.2 L296,9.8 C296,4.4 291.6,0 286.2,0 C280.8,0 276.4,4.4 276.4,9.8 L276.4,88.2 C276.3,93.6 280.7,98 286.2,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,98 C260.8,98 265.2,93.6 265.2,88.2 L265.2,9.8 C265.2,4.4 260.8,0 255.4,0 C250,0 245.6,4.4 245.6,9.8 L245.6,88.2 C245.6,93.6 250,98 255.4,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,98 C230.1,98 234.5,93.6 234.5,88.2 L234.5,9.8 C234.5,4.4 230.1,0 224.7,0 C219.3,0 214.9,4.4 214.9,9.8 L214.9,88.2 C214.9,93.6 219.3,98 224.7,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,98 C199.4,98 203.8,93.6 203.8,88.2 L203.8,9.8 C203.8,4.4 199.4,0 194,0 C188.6,0 184.2,4.4 184.2,9.8 L184.2,88.2 C184.2,93.6 188.6,98 194,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,98 C168.6,98 173,93.6 173,88.2 L173,9.8 C173,4.4 168.6,0 163.2,0 C157.8,0 153.4,4.4 153.4,9.8 L153.4,88.2 C153.4,93.6 157.8,98 163.2,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,98 C137.9,98 142.3,93.6 142.3,88.2 L142.3,9.8 C142.3,4.4 137.9,0 132.5,0 C127.1,0 122.7,4.4 122.7,9.8 L122.7,88.2 C122.7,93.6 127.1,98 132.5,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,98 C107.2,98 111.6,93.6 111.6,88.2 L111.6,9.8 C111.6,4.4 107.2,0 101.8,0 C96.4,0 92,4.4 92,9.8 L92,88.2 C92,93.6 96.4,98 101.8,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,98 C76.5,98 80.9,93.6 80.9,88.2 L80.9,9.8 C80.9,4.4 76.5,0 71.1,0 C65.7,0 61.3,4.4 61.3,9.8 L61.3,88.2 C61.3,93.6 65.7,98 71.1,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,98 C45.7,98 50.1,93.6 50.1,88.2 L50.1,9.8 C50.1,4.4 45.7,0 40.3,0 C34.9,0 30.5,4.4 30.5,9.8 L30.5,88.2 C30.5,93.6 34.9,98 40.3,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9,208.3 C322.3,208.3 326.7,203.9 326.7,198.5 L326.7,120.1 C326.7,114.7 322.3,110.3 316.9,110.3 C311.5,110.3 307.1,114.7 307.1,120.1 L307.1,198.5 C307.1,203.9 311.5,208.3 316.9,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,98 C15.3,98 19.7,93.6 19.7,88.2 L19.7,9.8 C19.7,4.4 15.3,0 9.9,0 C4.5,0 0.1,4.4 0.1,9.8 L0.1,88.2 C0.1,93.6 4.5,98 9.9,98 Z",
    id: "Shape",
    fill: "url(#linearGradient-256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,208.3 C15.3,208.3 19.7,203.9 19.7,198.5 L19.7,120.1 C19.7,114.7 15.3,110.3 9.9,110.3 C4.5,110.3 0.1,114.7 0.1,120.1 L0.1,198.5 C0.1,203.9 4.5,208.3 9.9,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,158.1 C291.6,158.1 296,153.7 296,148.3 L296,120.1 C296,114.7 291.6,110.3 286.2,110.3 C280.8,110.3 276.4,114.7 276.4,120.1 L276.4,148.3 C276.3,153.7 280.7,158.1 286.2,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-258)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,208.3 C260.8,208.3 265.2,203.9 265.2,198.5 L265.2,120.1 C265.2,114.7 260.8,110.3 255.4,110.3 C250,110.3 245.6,114.7 245.6,120.1 L245.6,198.5 C245.6,203.9 250,208.3 255.4,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,158.1 C230.1,158.1 234.5,153.7 234.5,148.3 L234.5,120.1 C234.5,114.7 230.1,110.3 224.7,110.3 C219.3,110.3 214.9,114.7 214.9,120.1 L214.9,148.3 C214.9,153.7 219.3,158.1 224.7,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,208.3 C199.4,208.3 203.8,203.9 203.8,198.5 L203.8,120.1 C203.8,114.7 199.4,110.3 194,110.3 C188.6,110.3 184.2,114.7 184.2,120.1 L184.2,198.5 C184.2,203.9 188.6,208.3 194,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,158.1 C168.6,158.1 173,153.7 173,148.3 L173,120.1 C173,114.7 168.6,110.3 163.2,110.3 C157.8,110.3 153.4,114.7 153.4,120.1 L153.4,148.3 C153.4,153.7 157.8,158.1 163.2,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,208.3 C137.9,208.3 142.3,203.9 142.3,198.5 L142.3,120.1 C142.3,114.7 137.9,110.3 132.5,110.3 C127.1,110.3 122.7,114.7 122.7,120.1 L122.7,198.5 C122.7,203.9 127.1,208.3 132.5,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,158.1 C107.2,158.1 111.6,153.7 111.6,148.3 L111.6,120.1 C111.6,114.7 107.2,110.3 101.8,110.3 C96.4,110.3 92,114.7 92,120.1 L92,148.3 C92,153.7 96.4,158.1 101.8,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,208.3 C76.5,208.3 80.9,203.9 80.9,198.5 L80.9,120.1 C80.9,114.7 76.5,110.3 71.1,110.3 C65.7,110.3 61.3,114.7 61.3,120.1 L61.3,198.5 C61.3,203.9 65.7,208.3 71.1,208.3 Z",
    id: "Shape",
    fill: "url(#linearGradient-265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,158.1 C45.7,158.1 50.1,153.7 50.1,148.3 L50.1,120.1 C50.1,114.7 45.7,110.3 40.3,110.3 C34.9,110.3 30.5,114.7 30.5,120.1 L30.5,148.3 C30.5,153.7 34.9,158.1 40.3,158.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,207.1 C291.6,207.1 296,202.7 296,197.3 L296,178.5 C296,173.1 291.6,168.7 286.2,168.7 C280.8,168.7 276.4,173.1 276.4,178.5 L276.4,197.3 C276.3,202.7 280.7,207.1 286.2,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,207.1 C230.1,207.1 234.5,202.7 234.5,197.3 L234.5,178.5 C234.5,173.1 230.1,168.7 224.7,168.7 C219.3,168.7 214.9,173.1 214.9,178.5 L214.9,197.3 C214.9,202.7 219.3,207.1 224.7,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,207.1 C168.6,207.1 173,202.7 173,197.3 L173,178.5 C173,173.1 168.6,168.7 163.2,168.7 C157.8,168.7 153.4,173.1 153.4,178.5 L153.4,197.3 C153.4,202.7 157.8,207.1 163.2,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,207.1 C107.2,207.1 111.6,202.7 111.6,197.3 L111.6,178.5 C111.6,173.1 107.2,168.7 101.8,168.7 C96.4,168.7 92,173.1 92,178.5 L92,197.3 C92,202.7 96.4,207.1 101.8,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,207.1 C45.7,207.1 50.1,202.7 50.1,197.3 L50.1,178.5 C50.1,173.1 45.7,168.7 40.3,168.7 C34.9,168.7 30.5,173.1 30.5,178.5 L30.5,197.3 C30.5,202.7 34.9,207.1 40.3,207.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-271)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 856.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1155.5,75 C1150.7,75 1146.2,76.3 1142.4,78.6 C1132.3,34 1092.4,0.6 1044.7,0.6 C1019.2,0.6 995.9,10.1 978.3,25.8 C962.4,13.6 942.5,6.4 921,6.4 C887,6.4 857.2,24.4 840.6,51.3 C832.7,47.1 823.7,44.7 814.1,44.7 C790.5,44.7 770.3,59.3 762,80 C757.7,76.9 752.5,75 746.8,75 C732.5,75 721,86.6 721,100.8 L758,100.8 L772.6,100.8 L826.5,100.8 L870.1,100.8 L944.5,100.8 L1015.3,100.8 L1129.7,100.8 L1144.9,100.8 L1181.4,100.8 C1181.3,86.5 1169.7,75 1155.5,75 Z",
    id: "Shape",
    fill: "url(#linearGradient-272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.1,75 C557.8,75 553.8,76 550.3,77.9 C541.5,58.4 521.9,44.7 499.1,44.7 C487.4,44.7 476.6,48.3 467.6,54.4 C455.4,41.6 438.1,33.6 419,33.6 C401.1,33.6 384.9,40.6 372.9,52 C355.8,21.4 323,0.7 285.5,0.7 C237.2,0.7 196.9,34.9 187.4,80.4 C183,77.1 177.6,75.1 171.7,75.1 C157.4,75.1 145.9,86.7 145.9,100.9 L185.3,100.9 L197.5,100.9 L351.8,100.9 L385.6,100.9 L443,100.9 L486.2,100.9 L536.3,100.9 L555.2,100.9 L587.9,100.9 C587.9,86.5 576.4,75 562.1,75 Z",
    id: "Shape",
    fill: "url(#linearGradient-273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,86.8 C16.3,86.8 18.5,87.4 20.4,88.4 C25.2,77.8 35.8,70.4 48.1,70.4 C54.4,70.4 60.3,72.3 65.2,75.7 C71.8,68.8 81.2,64.4 91.5,64.4 C101.2,64.4 110,68.2 116.5,74.3 C125.8,57.7 143.5,46.5 163.9,46.5 C190.1,46.5 211.9,65 217.1,89.7 C219.5,87.9 222.4,86.8 225.6,86.8 C233.3,86.8 239.6,93.1 239.6,100.8 L218.2,100.8 L211.6,100.8 L128,100.8 L109.7,100.8 L78.5,100.8 L55.1,100.8 L28,100.8 L17.7,100.8 L0,100.8 C0,93.1 6.3,86.8 14,86.8 Z",
    id: "Shape",
    fill: "url(#linearGradient-274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.39892,86.8 C1070.69893,86.8 1072.89894,87.4 1074.79895,88.4 C1079.59897,77.8 1090.19902,70.4 1102.49908,70.4 C1108.79911,70.4 1114.69914,72.3 1119.59916,75.7 C1126.1992,68.8 1135.59924,64.4 1145.89929,64.4 C1155.59934,64.4 1164.39938,68.2 1170.89941,74.3 C1180.19945,57.7 1197.89954,46.5 1218.29964,46.5 C1244.49976,46.5 1266.29987,65 1271.49989,89.7 C1273.8999,87.9 1276.79992,86.8 1279.99993,86.8 C1287.69997,86.8 1294,93.1 1294,100.8 L1272.5999,100.8 L1265.99987,100.8 L1182.39947,100.8 L1164.09938,100.8 L1132.99923,100.8 L1109.59912,100.8 L1082.49899,100.8 L1072.19894,100.8 L1054.49768,100.8 C1054.39885,93.1 1060.69888,86.8 1068.39892,86.8 Z",
    id: "Shape",
    fill: "url(#linearGradient-275)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(408.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#5469B2",
    fillRule: "nonzero",
    transform: "translate(218.118500, 342.303100) rotate(90.000000) translate(-218.118500, -342.303100) ",
    x: -123.6315,
    y: 138.9031,
    width: 683.5,
    height: 406.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "url(#linearGradient-276)",
    fillRule: "nonzero",
    x: 34.3,
    y: 36,
    width: 367.6,
    height: 612.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.9,317 L196.3,309.7 L193.1,303 L188.8,297 L183.8,291.7 L178.4,286.6 L171.6,283.5 L164.4,281.8 L157.2,280.8 L149.9,281.2 L142.2,281.6 L134.5,282.6 L126.8,283.7 L119.1,284.7 L111.6,286.7 L103.9,287.3 L100,287.7 L94.2,289.6 L88.4,291.7 L83.7,295.6 L77.2,301.2 L71,307.2 L68.1,312.6 L65,317.8 L61.8,322.9 L58.9,331.2 L55.7,339.5 L54.8,347.4 L54.5,355.3 L53.9,361.9 L54.8,368.5 L55.8,375 L56.5,381.6 L58.2,388.8 L60.4,395.8 L63,402.7 L65.7,409.7 L67.7,417 L70.7,423.9 L73.9,430.7 L76,437.9 L79.3,445.1 L81.4,452.7 L84.3,460.1 L79.9,466 L77.2,472.7 L75.8,479.8 L76.6,486.6 L78,493.4 L82.1,499 L86.7,504.1 L92.4,507.7 L98.5,511 L105.4,511.3 L112.3,511.5 L118.9,509.3 L125,505.9 L129.7,500.8 L133.6,495.2 L136.6,489 L137.1,482.1 L137,480.3 L138.9,474.7 L141.1,465.3 L141.1,462.2 L140.8,454.8 L140.3,447.4 L139.7,440 L138.5,433.4 L136.5,426.9 L135.8,420.2 L133.7,413.4 L132.1,406.5 L131.2,399.4 L130,392.4 L128.6,385.4 L126.9,378.3 L126.6,371 L126.7,365.9 L134.4,365.8 L142,366 L149.6,365.6 L157.2,364.9 L161.5,365 L168.6,362.8 L175.4,360 L181.7,356.1 L187.4,351.3 L191.1,344.8 L194.5,338.3 L196.7,331.3 L197.8,324.1 L197.9,317 Z M127.9,360.1 L129,359.2 L129.6,358.7 L130.3,358.8 L131.5,359.5 L127.9,360.1 Z",
    id: "Shape",
    fill: "url(#linearGradient-277)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.1,355.4 L287.1,347.4 L285.4,339.6 L283.5,331 L279.7,323 L277.5,317.3 L273.8,312.5 L270.5,307.4 L264.5,301.2 L257.9,295.6 L253,291.9 L247.3,289.7 L241.5,287.6 L237.6,287.7 L230,286.3 L222.3,285.2 L214.6,284.3 L207,282.9 L199.4,281.7 L191.7,280.9 L187.5,280.3 L180.1,281.1 L172.7,282.1 L165.9,285 L159.9,289.4 L154.7,294.6 L150.3,300.5 L146.1,306.6 L144.7,313.9 L143.3,321.1 L143.5,328.5 L145.1,335.7 L148,342.5 L151.9,348.8 L157.5,353.6 L163.3,358.1 L169.7,361.8 L176.8,363.8 L184.1,364.9 L191.7,365.6 L199.3,365.5 L206.9,365.5 L214.6,365.7 L214.3,370.8 L213.7,378 L212.7,385.2 L211.5,392.2 L210.2,399.2 L208.2,406 L207.1,413.1 L206,420.1 L204.1,426.6 L202.7,433.2 L201.5,439.8 L200.5,447.2 L200.5,454.7 L200.2,462.1 L200.2,465.2 L202.5,474.5 L205.5,483 L208.8,490 L213.4,496.2 L219.2,501.4 L226.5,504.3 L234.2,505.7 L241.1,505.3 L247.7,503 L253.7,499.6 L258.5,494.7 L262.6,489.2 L265.5,482.9 L266,476 L265.2,468.5 L263.3,461.1 L259,454.9 L261,449.3 L262.8,443.4 L264.7,437.5 L267.4,430.5 L271,423.9 L273.4,416.8 L275.6,409.6 L278.2,402.6 L280.5,395.6 L283.2,388.7 L285,381.6 L286.2,375.1 L287.2,368.5 L286.8,361.8 L287.1,355.4 Z M211,358.8 L211.8,358.9 L212.7,358.9 L213.5,360.1 L209.8,359.2 L211,358.8 Z",
    id: "Shape",
    fill: "url(#linearGradient-278)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.000000, 392.000000)",
    fill: "#DAE0EC",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,18.5 C11.7,20.1 11.9,20.3 9.2,21.9 C6.5,23.5 6.6,23.6 3.9,25.2 C3.9,25.2 4.1,24.8 4.1,24.8 C3.6,22.7 3.1,20.6 3.1,18.5 C3.1,16.3 3,14.1 3.6,12 C4.1,9.9 5.6,8.2 6.6,6.3 C6.7,6.2 6.2,5.9 6.3,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8,10.1 C4.7,10.7 4.7,11 0.6,11.6 C0.6,11.6 0.3,11.4 0.3,11.4 C0.6,9.2 1.9,7.3 2.9,5.5 C4,3.6 5.4,2.1 7.1,0.7 C7.2,0.6 7,0.5 7.1,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,25 C13.2,27.9 13.5,28.2 10.5,31.1 C10.5,31.1 10.5,30.6 10.5,30.6 C9.5,28.6 8.5,26.7 8.3,24.6 C8.1,22.5 8,20.2 8.6,18.1 C8.6,18 9.2,18.2 9.2,18.1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283,250.4 C301.6,328.5 246,405.5 168,407.5 C166.9,407.5 165.9,407.5 164.8,407.5 C96.5,407.5 52.7,351.5 50.6,281.5 C50.5,279 50.7,276.5 51.2,274 L61,178.1 C68.2,129.9 106.1,92.8 153.2,88 C207.3,82.5 256.3,121.2 265.3,176.5 L283,250.4 Z",
    id: "Shape",
    fill: "url(#linearGradient-279)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(281.000000, 257.000000)",
    fill: "#CBD5E6",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6,19 C4.4,18.8 4.4,18.4 8.2,18.2 C12,18 12,18.5 15.9,18.3 C15.9,18.3 15.4,18.4 15.4,18.4 C14.5,15.9 13.6,13.4 12.1,11.2 C10.6,9 9.4,6.5 7.4,4.7 C5.4,2.9 2.8,2 0.4,0.8 C0.2,0.7 0.2,0.8 1.13686838e-13,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9,29 C9,29.4 9,29.4 14.1,29.8 C14.1,29.8 14.4,29.4 14.4,29.4 C13.8,26.8 12.8,24.1 11.3,21.9 C9.8,19.7 7.3,18.4 5.1,16.9 C5,16.8 5.3,16.5 5.2,16.4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265,252.6 C264.2,249.2 264.8,249.1 264,245.7 C263.2,242.3 262.4,242.5 261.6,239.1 C260.8,235.7 261.1,235.6 260.3,232.2 C259.5,228.8 259.9,228.7 259.1,225.3 C258.3,221.9 257.8,222 257,218.6 C256.2,215.2 255.9,215.3 255,211.9 C254.2,208.5 254.7,208.4 253.9,205 C253.1,201.6 252.7,201.7 251.9,198.3 C251.1,194.9 251.5,194.8 250.7,191.4 C249.9,188 249.4,188.1 248.5,184.7 C247.7,181.3 248.3,181.2 247.5,177.8 C247.4,177.4 246.8,177.5 246.8,177 C246.4,174.6 246.3,172.2 245.7,169.9 C245.1,167.6 244.1,165.3 243.3,163.1 C242.5,160.8 241.3,158.7 240.3,156.5 C239.3,154.3 238.4,152.1 237.3,150 C236.1,147.9 234.6,146.1 233.2,144.1 C231.8,142.1 231,139.7 229.5,137.9 C228,136 225.9,134.7 224.2,133 C222.5,131.3 221,129.4 219.1,127.9 C217.3,126.3 215.4,124.9 213.4,123.5 C211.4,122.1 209.3,120.9 207.3,119.7 C205.2,118.5 203.3,117.1 201.1,116 C198.9,115 196.8,113.9 194.5,113.1 C192.3,112.3 189.8,111.8 187.5,111.2 C185.2,110.6 182.9,109.9 180.5,109.5 C178.1,109.1 175.7,109.2 173.3,109 C170.9,108.8 168.5,108.1 166.1,108.1 C163.4,108.1 160.7,108.3 158,108.5 C155.6,108.7 153.3,109.5 150.9,110 C148.5,110.4 146.3,111.3 144,111.9 C141.7,112.5 139.4,113.3 137.2,114.2 C134.9,115 132.4,115.1 130.2,116.2 C128,117.2 126.3,119.1 124.2,120.3 C122.1,121.5 119.9,122.5 117.9,123.9 C115.9,125.3 114,126.7 112.1,128.3 C110.3,129.9 108.5,131.5 106.8,133.2 C105.1,134.9 103.5,136.7 102,138.6 C100.5,140.5 98.9,142.3 97.6,144.3 C96.3,146.3 95.7,148.8 94.5,150.9 C93.3,153 92.2,155.1 91.2,157.3 C90.2,159.5 89,161.6 88.2,163.9 C87.4,166.2 86.9,168.5 86.3,170.8 C85.7,173.1 85.1,175.4 84.7,177.8 C84.3,181.4 83.9,181.3 83.6,184.9 C83.2,188.5 83.6,188.5 83.3,192.1 C82.9,195.7 83.2,195.7 82.8,199.3 C82.4,202.9 82.5,202.9 82.1,206.5 C81.7,210.1 81.1,210 80.7,213.6 C80.3,217.2 80.3,217.2 79.9,220.8 C79.5,224.4 79.6,224.4 79.2,228 C78.8,231.6 78.9,231.6 78.5,235.2 C78.1,238.8 78.3,238.8 77.9,242.4 C77.5,246 77,245.9 76.7,249.5 C76.3,253.1 76.8,253.1 76.4,256.7 C76,260.3 76.5,260.3 76.1,263.9 C75.7,267.5 75.9,267.6 74.8,271 C72.5,273.1 70.5,275.6 69.3,278.6 C69.3,278.6 69.5,279 69.5,279 C71.7,279.2 72.2,277.8 73.8,279.4 C72.3,281.9 71.7,284.5 70.9,287.3 C70.1,290.1 69.4,292.5 69.4,295.5 C72.7,296 72.6,292.6 75.8,293.5 C74.8,296.9 74.8,300.7 75.6,304.3 C76.6,305.1 76.3,303.1 77.4,303.6 C78,306.1 78.8,308.4 79.6,310.8 C80.3,313.3 81.1,315.7 81.9,318.1 C82.8,320.5 83.3,323.1 84.3,325.4 C85.4,327.8 86.8,329.9 88,332.2 C89.2,334.5 90.4,336.8 91.8,338.9 C93.2,341.1 94.5,343.3 96.1,345.3 C97.7,347.4 99.5,349.2 101.2,351.1 C102.9,353 104.5,354.8 106.3,356.5 C108.1,358.2 110.2,359.6 112.2,361.1 C114.2,362.6 116,364.3 118.1,365.6 C120.2,367 122.2,368.5 124.3,369.7 C126.5,370.9 129,371.5 131.3,372.4 C133.6,373.4 135.9,374.1 138.3,374.8 C140.6,375.6 142.9,376.9 145.3,377.4 C147.7,378 150.2,378.3 152.7,378.6 C155.1,379 157.6,379.3 160.1,379.5 C162.5,379.7 165,379.4 167.6,379.4 C168.5,379.4 169.4,379 170.3,379 C172.8,378.9 175.3,378.7 177.7,378.5 C180.2,378.3 182.8,378.8 185.2,378.3 C187.7,377.9 190,377 192.4,376.4 C194.8,375.8 197,374.6 199.4,373.8 C201.8,373 204.1,372.2 206.4,371.2 C208.7,370.2 210.9,369.2 213.1,368 C215.3,366.9 217.8,366.2 219.9,364.9 C222,363.6 224.2,362.3 226.2,360.8 C228.2,359.3 230.2,357.8 232.1,356.2 C234,354.6 235.9,353 237.7,351.2 C239.5,349.5 240.5,347 242.2,345.2 C243.8,343.3 245.8,341.7 247.3,339.7 C248.7,337.8 250.2,336 251.5,334 C252.8,332 253.6,329.8 254.8,327.7 C256,325.6 257.5,323.8 258.5,321.6 C259.5,319.5 259.9,317.1 260.8,314.9 C261.7,312.7 262.7,310.6 263.4,308.3 C264.1,306 265.4,303.9 266,301.7 C266.6,299.4 266.2,296.9 266.6,294.6 C267,292.3 267.2,290 267.5,287.6 C267.7,285.3 268.4,282.9 268.4,280.6 C268.5,278.2 268,275.9 267.9,273.5 C267.8,271.1 268.5,268.7 268.2,266.4 C268,264.1 267.2,261.8 266.8,259.4 C266.3,257.2 265.6,254.9 265,252.6 Z",
    id: "Shape",
    fill: "#DBE1EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9,88.2 C5.3,56 24.7,25.7 55.4,15.5 C69.4,10.9 84.5,10.9 98.5,15.5 C128,25.3 147.2,53.8 145.3,84.8 L145.1,88.2 C142.9,122.4 114.5,149.1 80.2,149.1 L73.8,149.1 C39.4,149.1 11,122.4 8.9,88.2 Z",
    id: "Shape",
    fill: "#BCCADE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2,104.5 L74.5,104.5 C61.2,104.5 50.4,93.7 50.4,80.4 C50.4,67.1 61.2,56.3 74.5,56.3 L94.2,56.3 C107.5,56.3 118.3,67.1 118.3,80.4 C118.3,93.7 107.5,104.5 94.2,104.5 Z",
    id: "Shape",
    fill: "#DBE1EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,77.6 L73.1,77.6 C69.6,77.6 66.8,74.8 66.8,71.3 L66.8,67.1 C66.8,63.6 69.6,60.8 73.1,60.8 L87.1,60.8 C90.6,60.8 93.4,63.6 93.4,67.1 L93.4,71.3 C93.4,74.7 90.6,77.6 87.1,77.6 Z",
    id: "Shape",
    fill: "#9BB0C9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#9BB0C9",
    fillRule: "nonzero",
    cx: 113.4,
    cy: 49.1,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#9BB0C9",
    fillRule: "nonzero",
    cx: 51.2,
    cy: 49.1,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6,77.1 L80.6,85.2 C80.6,85.5 80.3,85.7 80,85.6 C79.8,85.6 79.6,85.4 79.6,85.2 L78.6,77.1 C78.5,76.3 79.1,75.5 79.9,75.4 C80.7,75.3 81.5,75.9 81.6,76.7 C81.6,76.8 81.6,76.9 81.6,77.1 Z",
    id: "Shape",
    fill: "#9BB0C9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,94.4 L102.2,94.4",
    id: "Shape",
    stroke: "#9BB0C9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#BCCADE",
    fillRule: "nonzero",
    cx: 139.5,
    cy: 30.6,
    r: 15.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.3,31.8 C151.2,37.4 124.9,31.3 131.3,27.9 C137.8,24.5 145.4,26.2 148.3,31.8 Z",
    id: "Shape",
    fill: "#DBE1EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#BCCADE",
    fillRule: "nonzero",
    cx: 15.3,
    cy: 30.6,
    r: 15.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4,31.3 C3.5,36.9 29.8,30.8 23.4,27.4 C17,24 9.3,25.8 6.4,31.3 Z",
    id: "Shape",
    fill: "#DBE1EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9,20.8 C79.2,17.4 78.5,17.5 77.8,14.1 C77.1,10.7 77,10.7 76.3,7.3 C75.6,3.9 76.9,3.6 76.1,0.2 C76.1,0.2 75.6,1.2 75.6,1.2 C73.7,2.2 72,3.4 70.3,4.7 C68.6,6 66.1,6.5 64.6,8 C63.1,9.5 61.9,11.4 60.6,13.2 C59.3,15 59,17.2 58,19.2 C57,21.1 55.8,22.8 55.1,24.9 C55,25.1 53.8,24.7 53.7,24.9",
    id: "Shape",
    fill: "#BCCADE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3,26 C88.6,22.6 87.4,22.8 86.7,19.4 C86,16 85.8,16 85.1,12.6 C84.4,9.2 84.3,9.2 83.6,5.8 C83.6,5.8 84.3,5.7 84.3,5.7 C82.4,6.7 80.8,8.2 79.1,9.5 C77.4,10.8 75.7,12.1 74.2,13.7 C72.7,15.2 70.4,16.2 69.1,17.9 C67.8,19.7 66.5,21.6 65.5,23.5 C64.5,25.4 64,27.7 63.3,29.7 C63.2,29.9 63.9,30.2 63.8,30.4",
    id: "Shape",
    fill: "#BCCADE",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.000000, 494.000000)",
    fill: "#9BB0C9",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3,16.9 L4.6,4.4 C5.7,1.2 9.6,-0.1 12.4,1.8 C15.2,3.7 15.5,7.7 13,10 L3.1,18.8 C1.7,20 -0.3,18.6 0.3,16.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,25.7 L20.9,12.8 C21.7,9.5 25.4,7.8 28.4,9.4 C31.4,11 32.1,15 29.8,17.5 L20.9,27.3 C19.6,28.6 17.5,27.4 17.9,25.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1,27.1 L38.2,13.9 C38,10.5 41,7.8 44.4,8.4 C47.7,9 49.6,12.7 48.1,15.7 L42.4,27.7 C41.6,29.4 39.2,28.9 39.1,27.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.000000, 488.000000)",
    fill: "#9BB0C9",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2,16.5 L44.9,4 C43.8,0.8 39.9,-0.5 37.1,1.4 C34.3,3.3 34,7.3 36.5,9.6 L46.4,18.4 C47.7,19.5 49.7,18.2 49.2,16.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6,25.2 L28.6,12.3 C27.8,9 24.1,7.3 21.1,8.9 C18.1,10.5 17.4,14.5 19.7,17 L28.6,26.8 C29.8,28.1 32,27 31.6,25.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,26.7 L11.3,13.5 C11.5,10.1 8.5,7.4 5.1,8 C1.8,8.6 -0.1,12.3 1.4,15.3 L7.1,27.3 C7.9,28.9 10.3,28.4 10.4,26.7 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#7394DB",
    fillRule: "nonzero",
    transform: "translate(4.562460, 146.274920) rotate(-137.095006) translate(-4.562460, -146.274920) ",
    x: 1.76239715,
    y: 143.474857,
    width: 5.60012569,
    height: 5.60012569
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 101.000000)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9BB0C9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1,21.7 L66.4,38.3 C64.4,42.6 59,43.8 55.3,40.8 C51.7,37.8 51.8,32.2 55.6,29.4 L70.4,18.7 C72.5,17.3 75.1,19.4 74.1,21.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9,1.3 L39.6,13.2 C40.5,16.3 38.3,19.4 35.1,19.5 C31.9,19.6 29.4,16.7 30.1,13.6 L32.8,1.4 C33.1,-0.2 35.4,-0.3 35.9,1.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1,6.2 L24.7,16.8 C26.4,19.5 25.1,23.1 22,24.1 C18.9,25 15.8,22.8 15.7,19.6 L15.2,7.1 C15,5.4 17.2,4.7 18.1,6.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1,16.9 L11.5,26.2 C13.7,28.6 13,32.3 10.1,33.8 C7.3,35.3 3.8,33.7 3.1,30.5 L0.3,18.3 C-0.1,16.7 1.9,15.7 3.1,16.9 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.2,88.4 C62.4,85 62.9,80.9 63.9,76.9 C64.4,74.9 65,73 65.7,71.2 C66.4,69.4 67.2,67.6 68,66 C70.2,61.7 71.7,56.7 71.9,51.5 C72.9,31.9 57.8,15.1 38.2,14.1 C18.6,13.1 1.8,28.2 0.8,47.8 L0.5,53.6 C-1.59317004e-14,62.4 0.6,70.8 2,79 C3.4,87.2 5.5,95.2 9,103.5 C10.8,107.7 12.8,111.9 15.8,116.4 L17,118.1 C17.4,118.7 17.9,119.3 18.3,119.9 C18.8,120.5 19.2,121.1 19.7,121.7 C20.2,122.3 20.8,123 21.3,123.6 L22.1,124.5 L23.1,125.5 C23.8,126.2 24.4,126.8 25.1,127.4 C25.9,128.1 26.7,128.8 27.6,129.4 C28,129.7 28.4,130 28.9,130.4 C29.4,130.7 29.9,131.1 30.4,131.4 C30.9,131.7 31.4,132 32,132.3 C32.5,132.6 33,132.9 33.7,133.2 C35,133.8 36.2,134.3 37.5,134.8 C40.4,135.7 43.3,136.4 46.6,136.5 C47.4,136.5 48.2,136.5 49,136.5 C49.8,136.5 50.5,136.4 51.3,136.3 C52.1,136.2 52.8,136.1 53.6,136 L54.7,135.8 C55.1,135.7 55.4,135.6 55.7,135.5 C57.1,135.2 62.2,88.6 62.2,88.4 Z",
    fill: "url(#linearGradient-280)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DBE1EE",
    points: "14.1 35.9 11.3 42.9 11.3 50.5 13.2 57.8 17.1 64.5 23.4 69.1 30.8 71 38.3 71.3 45.9 69.9 51.8 65 57.1 59.3 59.2 51.9 59.5 44.2 57.5 36.8 53.1 30.4 46.8 26 39.8 22.9 32.1 23.3 24.8 25.5 18.6 29.8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(244.000000, 80.000000)",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9BB0C9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,26 L10.3,41.8 C12.7,45.8 18.3,46.5 21.6,43.2 C24.9,39.9 24.2,34.3 20.1,31.9 L4.2,22.7 C2.1,21.5 -0.3,23.9 1,26 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9,1.9 L34.5,14.2 C33.9,17.3 36.4,20.2 39.6,20 C42.8,19.8 45,16.6 44,13.6 L40.1,1.7 C39.5,0.1 37.2,0.2 36.9,1.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1,4.9 L49.6,16.1 C48.2,19 49.9,22.4 53,23 C56.1,23.6 59,21.1 58.8,17.9 L58.1,5.4 C58.1,3.9 55.9,3.4 55.1,4.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2,14.1 L63.8,24.2 C61.9,26.8 63,30.5 65.9,31.7 C68.9,32.9 72.2,30.9 72.6,27.7 L74.1,15.3 C74.3,13.6 72.1,12.7 71.2,14.1 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.8,137.5 C31.1,137.6 31.5,137.6 31.8,137.7 L32.9,137.8 C33.7,137.9 34.4,137.9 35.2,137.9 C36,137.9 36.7,137.9 37.5,137.9 C38.3,137.8 39.1,137.7 39.9,137.6 C43.1,137.2 46,136.2 48.8,135 C50,134.4 51.3,133.7 52.5,133 C53.1,132.6 53.6,132.3 54.1,131.9 C54.6,131.5 55.1,131.2 55.6,130.8 C56.1,130.4 56.6,130 57,129.7 C57.4,129.3 57.8,129 58.2,128.6 C59,127.9 59.7,127.1 60.5,126.4 C61.1,125.7 61.7,125 62.3,124.3 L63.2,123.2 L63.9,122.2 C64.4,121.5 64.9,120.9 65.3,120.2 C65.8,119.5 66.1,118.9 66.5,118.3 C66.9,117.7 67.3,117 67.6,116.4 L68.6,114.6 C71.1,109.8 72.7,105.3 74.1,101 C76.7,92.4 78,84.2 78.6,75.9 C79.1,67.6 78.8,59.2 77.5,50.5 L76.6,44.7 C73.6,25.3 55.4,12 35.9,15 C16.5,18 3.2,36.2 6.2,55.7 C7,60.8 8.9,65.7 11.6,69.7 C12.6,71.2 13.5,72.8 14.4,74.6 C15.2,76.4 16,78.2 16.7,80.1 C18.1,83.9 19,88 19.5,91.3 C19.7,91.4 29.5,137.2 30.8,137.5 Z",
    fill: "url(#linearGradient-281)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DBE1EE",
    points: "62.4 33.9 65.9 40.7 67.2 48.3 65.3 55.8 61.9 62.7 56.1 67.7 49.2 71.2 41.6 72 34.1 70.6 27.2 67.2 22.2 61.4 19 54.5 17.9 47 19.3 39.5 22.7 32.6 28.4 27.4 35.2 23.7 43 23 50.7 24.1 57.3 28.1"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(412.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5469B2",
    fillRule: "nonzero",
    points: "24.3 117.1 0.8 129.3 0.8 0.7 24.3 12.9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.2,
    cy: 2.4,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DDCCA2",
    fillRule: "nonzero",
    cx: 2.2,
    cy: 13.2,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.2,
    cy: 65.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#325187",
    fillRule: "nonzero",
    cx: 2.2,
    cy: 23.9,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2,34.6 L2.2,55.5",
    id: "Shape",
    stroke: "#6E98F0",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5469B2",
    fillRule: "nonzero",
    points: "24.3 116.4 0.8 128.6 0.8 0 24.3 12.2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.2,
    cy: 65.9,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.2,
    cy: 2.7,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#325187",
    fillRule: "nonzero",
    cx: 2.2,
    cy: 44.4,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2,33.7 L2.2,12.8",
    id: "Shape",
    stroke: "#6DFEFF",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 405.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5469B2",
    fillRule: "nonzero",
    points: "24.3 116.7 0.8 128.9 0.8 0.3 24.3 12.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.2,
    cy: 2.1,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.2,
    cy: 65.2,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2,34.6 L2.2,55.1",
    id: "Shape",
    stroke: "#DDCCA2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2,13.4 L2.2,25.6",
    id: "Shape",
    stroke: "#325187",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 405.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5469B2",
    fillRule: "nonzero",
    points: "0.6 12.5 24.1 0.3 24.1 128.9 0.6 116.7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DDCCA2",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 65.2,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 54.5,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 2.1,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#325187",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 43.7,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7,33 L2.7,12.1",
    id: "Shape",
    stroke: "#6E98F0",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5469B2",
    fillRule: "nonzero",
    points: "0.6 12.2 24.1 0 24.1 128.6 0.6 116.4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DDCCA2",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 65.9,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 55.2,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6DFEFF",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 2.7,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#325187",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 44.4,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7,33.7 L2.7,12.8",
    id: "Shape",
    stroke: "#6E98F0",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5469B2",
    fillRule: "nonzero",
    points: "0.6 12.9 24.1 0.7 24.1 129.3 0.6 117.1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 65.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 54.9,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6DFEFF",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 2.4,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#325187",
    fillRule: "nonzero",
    cx: 2.7,
    cy: 44.1,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7,33.4 L2.7,12.5",
    id: "Shape",
    stroke: "#6E98F0",
    strokeLinecap: "round"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-282)",
    fillRule: "nonzero",
    points: "890.8 957.1 361.4 957.1 545.2 13.6 707 13.6"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHanBear);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HanBear.936311667e17816a560c0fd3432e7e24.svg";